import React, { useState, useEffect, useRef, useContext } from "react";
import Select from "react-select";
import Container from "../../components/layout/Container/Container";
import Footer from "../../components/molecules/Footer/Footer";
import Header from "../../components/molecules/Header/Header";
import { useNavigate, useLocation } from "react-router-dom";
import { defaultAppContextData } from "../../services/appData";
import {
  getBioApplication,
  getBioCountryOfDestination,
  getCountries,
  saveBIOLabCancellation,
  getPshCavsTestCodeMaster,
  SaveBIODraftApplications,
  getBioCountryOfOrigin,
  getCAVSMaster,
  saveResultRequest,
  saveAckRequest,
  getAmendmentHistory,
} from "../../api/apimethods";
import { IBioSampleDetails } from "../../typings/models/BioSampleDetails";
import moment from "moment";
import { useSearchParams } from "react-router-dom";
import { IBioSamplesAndTests } from "../../typings/models/BioSamplesAndTests";
import { helper } from "../../utils/helper";
import { Button, Modal, Spinner, Tab, Tabs } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faTrashCan } from "@fortawesome/free-regular-svg-icons";
import {
  faCircleExclamation,
  faInfoCircle,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { BioMetaContext } from "../../App";
import { ITestPshCavsCodeMasterModel } from "../../typings/models/PshCavsTestCodeMasterModel";
import { IBioPurposeOfTest } from "../../typings/models/BioPurposeOfTest";
import { ILabTestDetails } from "../../typings/models/LabTestDetails";
import { ICodeMasterModel } from "../../typings/models/CodeMasterModel";
import { IChooseApp } from "../../typings/models/ChooseApp";
import { notify } from "../../utils";
import { ErrMsg, NotifyType } from "../../utils/app-config";
import {
  ApplicationStatus,
  TypeOfApplicationEnum,
  ApplicationTypeEnum,
} from "../../utils/enum";
import { IPersonalInfo } from "../../typings/models/PersonalInfo";
import {
  IBioRequest,
  defBIOCancelAppStatus,
} from "../../typings/interfaces/Requests/BioRequest";
import { IBioVaccineType } from "../../typings/models/BioVaccineType";
import { IBioVaccineName } from "../../typings/models/BioVaccineName";
import { IStepwizardProps } from "../../typings/models/StepwizardProps";
import { IlabBioPreference } from "../../typings/models/BioPreference";
import Stepwizard from "./Helper/Stepwizard";
import PersonalInformation, {
  initialPersonalInfo,
} from "./Helper/ProfileInformation";
import {
  IFilerInformation,
  tempFilerInfo,
} from "../../typings/models/FilerInformation";
import FileSaver from "file-saver";
import { IReactSelectOption } from "../../typings/models/ReactSelectOption";
import { ITestResult } from "../../typings/interfaces/Requests/TestResult";
import Loader from "../../components/molecules/Loader";
import { useContextService } from "../../services";
import { IAmendmentHistoryResponse } from "../../typings/interfaces/Responses/LabApplicationsResponse";
import AmendmentGrid from "./AmendmentGrid";
enum sampleDetailMandatoryFields {
  purposeOfTest = "purposeOfTest",
  vaccine_Biologics_Type = "vaccine_Biologics_Type",
  samplingFromDate = "samplingFromDate",
  samplingToDate = "samplingToDate",
  sampledBy = "sampledBy",
}

enum SamplesAndTestMandatoryFields {
  sampleMarking = "sampleMarking",
  labBioTestDetails = "labBioTestDetails",
}
enum PreferenceMandatoryFields {
  modeOfReceiving = "modeOfReceiving",
}

enum ResultMandatoryFields {
  resultcode = "resultcode",
  testingInstructions = "testingInstructions",
  remarksForThirdParty = "remarksForThirdParty",
}
const { message } = notify();

const stepWizardConfig: IStepwizardProps = {
  currentStep: 2,
  steps: [
    {
      name: "Choose Application",
    },

    {
      name: "Samples & Tests",
    },
    {
      name: "Review",
    },
    {
      name: "Cost & Confirm",
    },
    {
      name: "Acknowledgement",
    },
  ],
};
type RepeatCounts = {
  [sampleIndex: number]: {
    [testIndex: number]: number;
  };
};
const CAVSBioSamplesAndTests = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [btnNameForLoader, setBtnNameForLoader] = useState<string>("");
  const handleLoader = (enableLoader: boolean, btnNameOfLoader: string) => {
    setBtnNameForLoader(enableLoader ? btnNameOfLoader : "");
  };
  const [cancelButtonHidden, setCancelButtonHidden] = useState(false);
  const [searchLoading, setSearchLoading] = useState<boolean>(false);
  const currentDate = new Date();
  const [IsBiosurvillanceUser, setIsBiosurvillanceUser] = useState(false);
  currentDate.setDate(currentDate.getDate());
  const [validDates, setValidDates] = useState<boolean>(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const maxdate = currentDate.toISOString().split("T")[0];
  const maxDateTime = currentDate.toISOString().slice(0, 16);
  const [isHistoryExpanded, setHistoryExpanded] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showAmendmentHistory, setShowAmendmentHistory] = useState(false);
  const [amendmentHistory, setAmendmentHistory] = useState<
    IAmendmentHistoryResponse[]
  >([]);
  const [testOptions, setTestOptions] = useState<ITestPshCavsCodeMasterModel[]>(
    []
  );
  const [showPlaceholder, setShowPlaceholder] = useState(true);
  const [originalSampleDetails, setOriginalSampleDetails] =
    useState<IBioSampleDetails | null>(null);
  const [originalSamplesAndTests, setOriginalSamplesAndTests] = useState<
    IBioSamplesAndTests[]
  >([]);
  const { getContextValueFromStorage } = useContextService();
  const [contextData] = useState(() =>
    getContextValueFromStorage(defaultAppContextData)
  );
  const [modeOfPayment, setModeOfPayment] = useState<string>(
    localStorage.getItem("modeOfPayment") || ""
  );
  const user = contextData.user;
  const [activeTab, setActiveTab] = useState<number>(1);
  const [cancelMessage, setcancelMessage] = useState<string | null>(null);
  const [personalInfo, setPersonalInfo] =
    useState<IPersonalInfo>(initialPersonalInfo);
  const [customerName, setCustomerName] = useState<string>("");
  const [hasFetchedInitialData, setHasFetchedInitialData] = useState(false);
  const [salutation, setSalutation] = useState<string>("");
  const [rejectedTestsMessage, setRejectedTestsMessage] = useState("");
  const [clinicalHistoryOptions, setClinicalHistoryOptions] =
    useState<IBioPurposeOfTest[]>();
  const [testStatus, setTestStatus] = useState<string>("");
  const [showTooltip, setShowTooltip] = useState(false);
  const [bioSurveillanceProgramsOptions, setBioSurveillanceProgramsOptions] =
    useState<IReactSelectOption[]>([]);
  const [ResultCodeOptions, setResultCodeOptions] = useState<
    IReactSelectOption[]
  >([]);
  const [countryOptions, setCountryOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [BioSurveillanceValues, setBioSurveillanceValues] = useState<string[]>(
    []
  );
  const [isPostMartem, setIsPostMartem] = useState(0);
  const [amendCase, setAmendCase] = useState<string>("");
  const [submittedFeedback, setSubmittedFeedback] = useState<number>(0);
  const [copyCount, setCopyCount] = useState<number>(1);
  const [isCancelRequest, setIsCancelRequest] = useState<boolean>(false);
  const [IsAcknowledgeRequest, setIsAcknowledgeRequest] =
    useState<boolean>(false);
  const [IsAcknowledge, setIsAcknowledge] = useState<boolean>(false);
  const [IsSubmitresultRequest, setIsSubmitresultRequest] =
    useState<boolean>(false);
  const [cancelComments, setCancelComments] = useState<string>("");
  const [cancelCommentsErrMsg, setCancelCommentsErrMsg] = useState<string>("");
  const [labtestoptions, setlabtestoptions] = useState<
    ITestPshCavsCodeMasterModel[]
  >([]);
  const [repeatCounts, setRepeatCounts] = useState<RepeatCounts>({});
  const [selectedTestLaboratory, setSelectedTestLaboratory] =
    useState("All-laboratories");
  const [errorMessage, setErrorMessage] = useState("");
  const [RedMessage, setRedMessage] = useState("");
  const [labTestID, setlabTestID] = useState<string>("");
  const [testDescription, setTestDescription] = useState<string>("");
  const [showSearchTestsModal, setShowSearchTestsModal] = useState(false);
  const [searchInd, setSearchInd] = useState(-1);
  const [selectedTestIds, setSelectedTestIds] = useState<
    (number | undefined)[]
  >([]);
  const { BioMeta } = useContext(BioMetaContext);
  const [acknowledgmentMessage, setAcknowledgmentMessage] = useState<
    string | null
  >(null);
  const [actionType, setActionType] = useState<string>("");
  const [reportgenerated, setreportgenerated] = useState<number>(0);
  const [applicationNum, setApplicationNum] = useState<string>("");
  const { fileToBase64, getFilerInfomation } = helper();
  const [pageLoader, setPageLoader] = useState<boolean>(false);
  const [checkpageLoader, setcheckPageLoader] = useState<boolean>(false);
  const [customerNRIC, setCustomerNRIC] = useState("");
  const [isVaccineExpanded, setVaccineExpanded] = useState(true);
  const [thirdPartyNric, setthirdPartyNric] = useState<string>("");
  const handleCloseSearchTestsModal = () => setShowSearchTestsModal(false);
  const [countries, setCountries] = useState<any[]>([]);
  const [params, setParams] = useSearchParams();
  const [purposeOfTestOptions, setPurposeOfTestOptions] =
    useState<IBioPurposeOfTest[]>();
  const [countryOfOriginOptions, setCountryOfOriginOptions] =
    useState<ICodeMasterModel[]>();
  const [isThirdPartyLab, setisThirdPartyLab] = useState<string>("");
  const [countryOfDestinationOptions, setCountryOfDestinationOptions] =
    useState<ICodeMasterModel[]>();
  const [vaccineTypeOptions, setVaccineTypeOptions] =
    useState<IBioVaccineType[]>();
  const [vaccineNameOptions, setVaccineNameOptions] =
    useState<IBioVaccineName[]>();
  const [vaccineNameOptionsBak, setVaccineNameOptionsBak] =
    useState<IBioVaccineName[]>();
  const testRowId = Number(params.get("rowId") ?? "");
  const handleMouseEnter = () => {
    setShowTooltip(true);
  };
  const handleMouseLeave = () => {
    setShowTooltip(false);
  };
  const stripHtmlTags = (str: string) => {
    return str.replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>/gi, "");
  };
  const strippedHtmlTags = (str: string) => {
    return str.replace(/<\/?[^>]+(>|$)/g, "").trim();
  };
  const postMartemFields = [
    "resultcode",
    "testingInstructions",
    "remarksForThirdParty",
  ];
  const [bioSampleDetails, setBioSampleDetails] = useState<IBioSampleDetails>({
    purposeOfTest: 0,
    crossReference: "",
    otherPurposeOfTest: "",
    samplesCollectedOrSubmitted: "Tobesubmitted",
    courierName: "",
    courierTrackingNo: "",
    countryOfOrigin: "",
    countryOfDestination: "",
    dateToBeExported: null,
    importPermitNo: "",
    dateOfImport: null,
    samplingFromDate: null,
    samplingToDate: null,
    sampledBy: "",
    noOfVialsSubmitted: "",
    dosesVial: "",
    vaccine_Biologics_Type: "",
    diluent_Batch_No: "",
    vaccineName: "",
    bioSurveillanceProgram: "",
    diluentExpiryDate: null,
    noOfVialsProduced: 0,
    dateProduced: null,
    substrate: "",
    history_Remarks: "",
  });
  const defaultTestResult: ITestResult = {
    resultcode: "",
    Readings: 0,
    Readings2: 0,
    Symbol1: 0,
    Symbol2: 0,
    Positive: "",
    Negative: "",
    testingInstructions: "",
    remarksForThirdParty: "",
    units: "",
    Indefinite: "",
    ResultRemarks: "",
    report: "",
    Parasitology: "",
    Microbiology: "",
    Histopathology: "",
    ourreference: "",
    finalDiagnosis: "",
    resultcodeErrMsg: "",
  };
  const mergeWithDefaults = (result: any) => ({
    ...defaultTestResult,
    ...result,
  });

  let samplesAndTestSchema: IBioSamplesAndTests = {
    id: Date.now(),
    sampleMarking: "",
    batchNo: "",
    longitude: "",
    latitude: "",
    noOfSamples: 1,
    antibioticSensitivityTestRequired: false,
    expiryDate: null,
    labBioTestDetails: [],
  };
  let labBioPreferenceSchema: IlabBioPreference = {
    specialInstructions: "",
    antimicrobialSusceptibilityTestRequired: false,
    remarks: "",
    supportDocuments: [],
    supportDocumentName: "",
    hardcopy: "",
    acknowledge: false,
    customAddress: "",
    modeOfReceiving: 0,
  };
  const reportTypeNames: { [key: number]: string } = {
    1: "Casesheet",
    2: "Laboratory Report",
    3: "Acknowledgment Slip",
    4: "Sample Label",
  };
  const [reports, setReports] = useState<
    {
      reportName: string;
      reportData: string;
      reportType: number;
      reportID: string;
      applicationId: string;
      isReportGenerated: any;
    }[]
  >([]);
  const renderReportType = (type: number) => {
    return reportTypeNames[type] || "Laboratory Report";
  };
  const [samplesAndTests, setSamplesAndTests] = useState<IBioSamplesAndTests[]>(
    [...[samplesAndTestSchema]]
  );
  const [Preference, setPreference] = useState<IlabBioPreference>(
    labBioPreferenceSchema
  );
  const [originalPreference, setOriginalPreference] =
    useState<IlabBioPreference>(labBioPreferenceSchema);
  const handleHistoryExpandToggle = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    e.preventDefault();
    setHistoryExpanded(!isHistoryExpanded);
  };

  const handleVaccineExpandToggle = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    e.preventDefault();
    setVaccineExpanded(!isVaccineExpanded);
  };
  const handleShowSearchTestsModal = (index: number) => {
    setSearchInd(index);
    setShowSearchTestsModal(true);
  };
  const prevModeOfPaymentRef = useRef(modeOfPayment);
  useEffect(() => {
    if (modeOfPayment === "Biosurveillance") {
      setBioSampleDetails((prevDetails) => ({
        ...prevDetails,
        purposeOfTest: 1,
      }));
    } else if (prevModeOfPaymentRef.current === "Biosurveillance") {
      setBioSampleDetails((prevDetails) => ({
        ...prevDetails,
        purposeOfTest: 0,
      }));
    }

    prevModeOfPaymentRef.current = modeOfPayment;
  }, [modeOfPayment]);

  useEffect(() => {
    if (IsSubmitresultRequest || IsAcknowledge) {
      setActiveTab(4);
    }
  }, [IsSubmitresultRequest, IsAcknowledge]);
  useEffect(() => {
    getMaster();
  }, []);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await getCountries();

        setCountries(response.data);
      } catch (error) {}
    };

    fetchCountries();
  }, []);

  const getMaster = async () => {
    try {
      setPageLoader(true);
      const getUserInfo = localStorage.getItem("app-data");
      const userInfo = JSON.parse(getUserInfo || "");
      let NRIC = userInfo?.user?.idNo || null;
      let UEN = userInfo?.user?.uen || null;
      let role = userInfo?.user?.role || "";
      setCustomerNRIC(role === "CorpPass" ? UEN : NRIC);
      const customerIdentifier = role === "CorpPass" ? UEN : NRIC;
      const response = await getCAVSMaster();
      if (response?.status === 200) {
        let cavsMaster = response.data;
        let bioMaster = cavsMaster.bioMasters;
        if (bioMaster) {
          let purposeTest = bioMaster.testPurpose;
          let values = Object.values(purposeTest);
          let purposeTestArr = Object.keys(purposeTest).map((x, ind) => {
            return {
              id: values[ind],
              name: x,
            };
          });
          if (bioMaster.bioSurveillances) {
            const fetchedBioSurveillanceValues = bioMaster.bioSurveillances.map(
              (service: any) => service.uen
            );
            setBioSurveillanceValues(fetchedBioSurveillanceValues);
            const isBioUser =
              Array.isArray(fetchedBioSurveillanceValues) &&
              fetchedBioSurveillanceValues.includes(customerIdentifier);
            setIsBiosurvillanceUser(isBioUser);
          }
          setPurposeOfTestOptions(purposeTestArr);
          setVaccineTypeOptions(bioMaster.vaccineTypes);
          setVaccineNameOptions(bioMaster.vaccineNames);
          setVaccineNameOptionsBak(bioMaster.vaccineNames);
          const resultCode = bioMaster.resultCodeMaster;
          if (resultCode) {
            const resultCodeArr = resultCode.map((result: any) => ({
              label: result.resultCodeName,
              value: result.resultCodeId,
            }));
            setResultCodeOptions(resultCodeArr);
          }

          const bioSurveillanceProgram = bioMaster.bioSurveillancePrograms;
          if (bioSurveillanceProgram) {
            const bioSurveillanceProgramArr = bioSurveillanceProgram.map(
              (result: any) => ({
                label: result.name,
                value: result.CodeValue,
              })
            );
            setBioSurveillanceProgramsOptions(bioSurveillanceProgramArr);
          }
        }
      }

      const countryRes = await getBioCountryOfDestination();
      setCountryOfDestinationOptions(countryRes?.data || []);
      const conutryRes = await getBioCountryOfOrigin();
      setCountryOfOriginOptions(conutryRes?.data || []);
      const countryOptions = (conutryRes?.data || []).map((country) => ({
        value: country.name,
        label: country.name,
      }));
      setCountryOptions(countryOptions);
      let clinicalHistory = response?.data?.bioMasters?.clinicalHistory;
      if (clinicalHistory) {
        let values: number[] = Object.values(clinicalHistory);
        let clinicalHistoryArr: IBioPurposeOfTest[] = Object.keys(
          clinicalHistory
        ).map((x, ind) => {
          return {
            id: values[ind],
            name: x,
          };
        });
        setClinicalHistoryOptions(clinicalHistoryArr);
      }

      const meta: IBioRequest = BioMeta.BioMeta;
      if (Object.keys(meta)?.length) {
        setBioSampleDetails(meta.labBIOApplicationDetails);
        setSamplesAndTests(meta.labBioSampleTestDetails);
        setPreference(meta.labBioPreference);
        const fromDate = meta.labBIOApplicationDetails.samplingFromDate;
        const toDate = meta.labBIOApplicationDetails.samplingToDate;

        if (moment(fromDate).isValid() && moment(toDate).isValid()) {
          setValidDates(true);
        } else {
          setValidDates(false);
        }
      }
      setPageLoader(false);
    } catch (ex) {
      console.error(ex);
      setPageLoader(false);
    }
  };

  const handleShowAmendmentHistory = async (appNo: string) => {
    if (!appNo) return;

    try {
      const amdresponse = await getAmendmentHistory(appNo);
      setAmendmentHistory(amdresponse);
      setShowAmendmentHistory(true);
    } catch (error) {
      console.error("Error fetching amendment history:", error);
    }
  };

  const handledCopyButtonClick = (
    sampleIndex: number,
    testLabTestID: string,
    resultIndex: number
  ) => {
    setSamplesAndTests((prevSamplesAndTests) => {
      const updatedSamplesAndTests = prevSamplesAndTests.map((sample) => {
        const updatedLabBIOTestDetails = sample.labBioTestDetails.map(
          (test) => {
            if (test.labTestID === testLabTestID) {
              const labBIOTestResult = Array.isArray(test.labBIOTestResult)
                ? test.labBIOTestResult
                : [];
              const valueToCopy = labBIOTestResult[resultIndex]
                ? { ...labBIOTestResult[resultIndex] }
                : defaultTestResult;

              const updatedLabBIOTestResult = [
                ...labBIOTestResult,
                valueToCopy,
              ];

              return {
                ...test,
                labBIOTestResult: updatedLabBIOTestResult,
              };
            }
            return test;
          }
        );

        if (
          sample.labBioTestDetails.some(
            (test) => test.labTestID === testLabTestID
          )
        ) {
        }

        return {
          ...sample,
          labBioTestDetails: updatedLabBIOTestDetails,
        };
      });

      return updatedSamplesAndTests;
    });
  };
  const handledFiledChange = async (
    sampleIndex: number,
    testLabTestID: string,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files) {
      const files = Array.from(event.target.files);
      const base64Files = await Promise.all(
        files.map((file) => fileToBase64(file))
      );

      const newResultDocuments = base64Files.filter(
        (base64) => base64.length > 0
      );
      const newResultDocumentNames = files.map((file) => file.name);

      setSamplesAndTests((prevState) => {
        const updatedSamples = prevState.map((sample, sIndex) => {
          const updatedLabBIOTestDetail = sample.labBioTestDetails.map(
            (test) => {
              if (test.labTestID === testLabTestID) {
                const updatedResultDocuments = [
                  ...(test.ResultDocuments || []),
                  ...newResultDocuments,
                ];
                const updatedResultDocumentNames = [
                  ...(test.ResultDocumentName
                    ? test.ResultDocumentName.split(", ")
                    : []),
                  ...newResultDocumentNames,
                ];

                return {
                  ...test,
                  ResultDocuments: updatedResultDocuments,
                  ResultDocumentName: updatedResultDocumentNames.join(", "),
                };
              }
              return test;
            }
          );

          return {
            ...sample,
            labBioTestDetails: updatedLabBIOTestDetail,
          };
        });

        return updatedSamples;
      });
    }
  };

  const handleSelectChange =
    (name: string) => (selectedOption: IReactSelectOption | null) => {
      const event = {
        target: {
          name,
          value: selectedOption ? selectedOption.value : "",
        },
      } as React.ChangeEvent<HTMLSelectElement>;
      handleBioSampleDetails(event, "string");
    };
  const handledSelectChange =
    (index: number, name: string, testIndex: string, resultIndex: number) =>
    (selectedOption: IReactSelectOption | null) => {
      const event = {
        target: {
          name,
          value: selectedOption ? selectedOption.value : "",
        },
      };
      handledSamplesAndTestsChange(
        index,
        "string",
        testIndex,
        resultIndex
      )(event as any);
    };

  const fetchLabTestOptions = async () => {
    try {
      const labMastersResponse: any = await getPshCavsTestCodeMaster({
        PurposeCode: "BIO",
        IsBiosurvillanceUser: IsBiosurvillanceUser,
      });
      const labMastersData = labMastersResponse.data;
      const labTestOptions = labMastersData.cavsLabMasters.map((item: any) => ({
        labGroupId: item.labGroupId,
        title: item.title,
        labGroup: item.labGroup,
      }));

      setlabtestoptions(labTestOptions);
    } catch (error) {
      console.error("Error fetching lab test options:", error);
    }
  };

  useEffect(() => {
    fetchLabTestOptions();
  }, []);

  const handledFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files) {
      let filesArray = Array.from(event.target.files);
      let documentsArray: { ID: string; Name: string; Attachment: string }[] =
        [];

      for (let file of filesArray) {
        const base64String = await fileToBase64(file);
        if (base64String.length) {
          documentsArray.push({
            ID: "",
            Name: file.name,
            Attachment: base64String,
          });
        }
      }

      if (documentsArray.length) {
        setPreference((prevState) => {
          return {
            ...prevState,
            supportDocuments: [
              ...(prevState.supportDocuments || []),
              ...documentsArray,
            ],
            supportDocumentName: [
              ...(prevState.supportDocumentName
                ? prevState.supportDocumentName.split(", ")
                : []),
              ...documentsArray.map((doc) => doc.Name),
            ].join(", "),
          } as typeof Preference;
        });
      }
    }
  };
  const handleRemoveFile = (fileName: string) => {
    setPreference((prevState) => {
      const fileIndex = prevState.supportDocumentName
        ?.split(", ")
        .indexOf(fileName);
      if (fileIndex === -1) return prevState;
      const updatedSupportDocuments = prevState.supportDocuments?.filter(
        (_, index) => index !== fileIndex
      );
      const updatedSupportDocumentNames = prevState.supportDocumentName
        ?.split(", ")
        .filter((_, index) => index !== fileIndex)
        .join(", ");
      return {
        ...prevState,
        supportDocuments: updatedSupportDocuments,
        supportDocumentName: updatedSupportDocumentNames,
      };
    });
  };
  const handledSamplesAndTestsChange =
    (
      altIndex: number,
      type: string,
      testLabTestID: string,
      resultIndex: number
    ) =>
    (
      e: React.ChangeEvent<
        HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
      >
    ) => {
      let newValue: boolean | number | string | undefined;
      if (type === "decimal") {
        newValue = Math.max(0, parseFloat(e.target.value));
      } else if (type === "number") {
        newValue = Math.max(0, parseInt(e.target.value));
      } else if (type === "date") {
        newValue = moment(e.target.value, "YYYY-MM-DD").toISOString();
      } else {
        newValue = e.target.value;
      }

      setSamplesAndTests((prevSamples) => {
        const updatedSamples = prevSamples.map((item) => {
          const updatedLabBIOTestDetails = item.labBioTestDetails.map(
            (test) => {
              if (test.labTestID === testLabTestID) {
                const updatedLabBIOTestResult = (
                  test.labBIOTestResult && test.labBIOTestResult.length > 0
                    ? test.labBIOTestResult
                    : [defaultTestResult]
                ).map((result, k) => {
                  if (k === resultIndex) {
                    return {
                      ...result,
                      [e.target.name]: newValue,
                    };
                  } else {
                    return result;
                  }
                });

                return {
                  ...test,
                  labBIOTestResult: updatedLabBIOTestResult,
                };
              } else {
                return test;
              }
            }
          );

          return {
            ...item,
            labBioTestDetails: updatedLabBIOTestDetails,
          };
        });

        return updatedSamples;
      });
    };

  const handleDeleteTestResult = (
    sampleIndex: number,
    testLabTestID: string,
    resultIndex: number
  ) => {
    setSamplesAndTests((prevSamples) => {
      const updatedSamples = prevSamples.map((item) => {
        const updatedLabBIOTestDetails = item.labBioTestDetails.map((test) => {
          if (test.labTestID === testLabTestID) {
            const updatedLabBIOTestResult = test.labBIOTestResult
              ? test.labBIOTestResult.filter((_, k) => k !== resultIndex)
              : [];

            if (updatedLabBIOTestResult.length === 0) {
              updatedLabBIOTestResult.push(defaultTestResult);
            }

            return {
              ...test,
              labBIOTestResult: updatedLabBIOTestResult,
            };
          } else {
            return test;
          }
        });

        return {
          ...item,
          labBioTestDetails: updatedLabBIOTestDetails,
        };
      });

      return updatedSamples;
    });
  };
  const handleMyPreference = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >,
    type: string
  ) => {
    setPreference((prevState) => {
      const target = e.target as HTMLInputElement;
      let value: string | boolean | number = target.value;

      switch (type) {
        case "radio":
          value = parseInt(target.value, 10);
          break;
        case "number":
          value = target.value ? parseInt(target.value, 10) : 1;
          break;
        case "checkbox":
          value = target.checked;
          break;
        default:
          break;
      }

      return {
        ...prevState,
        [target.name]: value,
      } as IlabBioPreference;
    });
  };

  const handleDownload = (fileName: string, reportData: string, index: number, totalReports: number,  applicationNum: string) => {
      try {
        const decodedData = atob(reportData);
        const byteCharacters = Array.from(decodedData).map((char) =>
          char.charCodeAt(0)
        );
        const byteArray = new Uint8Array(byteCharacters);
  
        const blob = new Blob([byteArray], { type: "application/pdf" });
  
        FileSaver.saveAs(blob, fileName);
  
      // ✅ Redirect only if this is the last record
      if (index === totalReports - 1) {
        setTimeout(() => {
          window.location.href = `/eservices/rating-feedback?an=${encodeURIComponent(applicationNum)}`;
        }, 800);
      }
        //window.location.href = `/eservices/rating-feedback?an=${applicationNum}`;
      } catch (error) {
        console.error(error);
        message(NotifyType.Info, "Error downloading the file");
      }
    };

  const validateForm = () => {
    let isValidAppDetils = true;
    let overAllValidFlag = true;
    let personalInfostorage: IPersonalInfo = { ...initialPersonalInfo };
    try {
      const storedProfileInfo = localStorage.getItem("profile-info");
      if (storedProfileInfo) {
        personalInfostorage = JSON.parse(storedProfileInfo);
      }
    } catch (error) {
      console.error("Error parsing profile-info from localStorage:", error);
    }

    if (!validDates) {
      overAllValidFlag = false;
      message(NotifyType.Error, "Please enter valid sampling date fields.");
    }
    let applicationDetailsManFields = Object.values(
      sampleDetailMandatoryFields
    );
    let tempApplicationDetails: any = bioSampleDetails;
    applicationDetailsManFields.forEach((x: any) => {
      let temp = tempApplicationDetails[x];
      if (typeof temp == "number") {
        if (!temp) {
          isValidAppDetils = false;
          tempApplicationDetails = {
            ...tempApplicationDetails,
            [`${x}ErrMsg`]: `Please fill ${x}.`,
          };
        } else {
          tempApplicationDetails = {
            ...tempApplicationDetails,
            [`${x}ErrMsg`]: ``,
          };
        }
      } else {
        if (!temp?.length) {
          isValidAppDetils = false;
          tempApplicationDetails = {
            ...tempApplicationDetails,
            [`${x}ErrMsg`]: `Please fill ${x}.`,
          };
        } else {
          tempApplicationDetails = {
            ...tempApplicationDetails,
            [`${x}ErrMsg`]: ``,
          };
        }
      }
    });
    if (bioSampleDetails?.purposeOfTest === 1) {
      if (!bioSampleDetails?.bioSurveillanceProgram?.length) {
        isValidAppDetils = false;
        tempApplicationDetails = {
          ...tempApplicationDetails,
          bioSurveillanceProgramErrMsg:
            "Please select a Biosurveillance Program.",
        };
      } else {
        tempApplicationDetails = {
          ...tempApplicationDetails,
          bioSurveillanceProgramErrMsg: "",
        };
      }
    }
    if (bioSampleDetails?.purposeOfTest === 4) {
      if (!bioSampleDetails?.dateToBeExported) {
        isValidAppDetils = false;
        tempApplicationDetails = {
          ...tempApplicationDetails,
          dateExportedDateErrMsg: "Please select Date to be exported.",
        };
      } else {
        tempApplicationDetails = {
          ...tempApplicationDetails,
          dateExportedDateErrMsg: "",
        };
      }

      if (!bioSampleDetails?.countryOfDestination?.length) {
        isValidAppDetils = false;
        tempApplicationDetails = {
          ...tempApplicationDetails,
          exportercountryOfDestinationErrMsg:
            "Please select Exporter Country of Destination.",
        };
      } else {
        tempApplicationDetails = {
          ...tempApplicationDetails,
          exportercountryOfDestinationErrMsg: "",
        };
      }
    } else {
      tempApplicationDetails = {
        ...tempApplicationDetails,
        exportercountryOfDestinationErrMsg: "",
        dateExportedDateErrMsg: "",
      };
    }
    setBioSampleDetails(tempApplicationDetails);
    if (!isValidAppDetils) {
      overAllValidFlag = false;
    }

    let isValidSampleAndTests = true;
    let manFieldsSampleAndTests = Object.values(SamplesAndTestMandatoryFields);
    const sampleMarkingsAll = samplesAndTests
      .map((s: any) => s.sampleMarking?.trim())
      .filter(Boolean);
    const duplicates = sampleMarkingsAll.filter(
      (mark, idx, arr) =>
        arr.indexOf(mark) !== idx && arr.lastIndexOf(mark) === idx
    );
    const newArray = samplesAndTests.map((item: any) => {
      manFieldsSampleAndTests.forEach((x: any) => {
        let temp = item[x];
        if (typeof temp == "number") {
          if (!temp) {
            isValidSampleAndTests = false;
            item = { ...item, [`${x}ErrMsg`]: `Please fill ${x}.` };
          } else {
            item = { ...item, [`${x}ErrMsg`]: `` };
          }
        } else {
          if (!temp?.length) {
            isValidSampleAndTests = false;
            item = { ...item, [`${x}ErrMsg`]: `Please fill ${x}.` };
          } else {
            item = { ...item, [`${x}ErrMsg`]: `` };
          }
        }
      });
      const trimmedMark = item.sampleMarking?.trim();
      if (!trimmedMark) {
        isValidSampleAndTests = false;
        item = { ...item, sampleMarkingErrMsg: "Please fill Sampling Marking" };
      } else if (duplicates.includes(trimmedMark)) {
        isValidSampleAndTests = false;
        item = {
          ...item,
          sampleMarkingErrMsg:
            "Sample Marking must be unique across all samples.",
        };
      } else {
        item = { ...item, sampleMarkingErrMsg: "" };
      }
      return item;
    });

    setSamplesAndTests(newArray);

    if (!isValidSampleAndTests) overAllValidFlag = false;
    let isValidPreferences = true;
    let preferenceFields = Object.values(PreferenceMandatoryFields);
    let tempPreferences: any = Preference;

    preferenceFields.forEach((x: any) => {
      let temp = tempPreferences[x];
      if (typeof temp === "number") {
        if (!temp) {
          isValidPreferences = false;
          tempPreferences = {
            ...tempPreferences,
            [`${x}ErrMsg`]: `Please fill ${x}.`,
          };
        } else {
          tempPreferences = {
            ...tempPreferences,
            [`${x}ErrMsg`]: ``,
          };
        }
      } else {
        if (!temp?.length) {
          isValidPreferences = false;
          tempPreferences = {
            ...tempPreferences,
            [`${x}ErrMsg`]: `Please fill ${x}.`,
          };
        } else {
          tempPreferences = {
            ...tempPreferences,
            [`${x}ErrMsg`]: ``,
          };
        }
      }
    });
    if (!Preference?.modeOfReceiving) {
      isValidPreferences = false;
      tempPreferences = {
        ...tempPreferences,
        modeOfReceivingErrMsg: "Please select Mode of Receiving.",
      };
    } else {
      tempPreferences = { ...tempPreferences, modeOfReceivingErrMsg: "" };

      if (Preference.modeOfReceiving === 1) {
        if (!Preference?.mailingAddress) {
          isValidPreferences = false;
          tempPreferences = {
            ...tempPreferences,
            mailingAddressErrMsg: "Please select the mailing address.",
          };
        } else if (
          Preference.mailingAddress === 3 &&
          !Preference?.customAddress?.length
        ) {
          isValidPreferences = false;
          tempPreferences = {
            ...tempPreferences,
            customAddressErrMsg: "Please enter the custom address.",
          };
        } else {
          tempPreferences = {
            ...tempPreferences,
            mailingAddressErrMsg: "",
            customAddressErrMsg: "",
          };
        }

        if (!Preference?.acknowledge) {
          isValidPreferences = false;
          tempPreferences = {
            ...tempPreferences,
            acknowledgeErrMsg: "You must acknowledge before proceeding.",
          };
        } else {
          tempPreferences = { ...tempPreferences, acknowledgeErrMsg: "" };
        }
      }
    }

    setPreference(tempPreferences);

    if (personalInfostorage) {
      if (!personalInfostorage?.address?.streetName?.trim()) {
        isValidPreferences = false;
        message(
          NotifyType.Error,
          "Please fill the mailing address street name fields."
        );
      }
      if (!personalInfostorage?.address?.postalCode?.trim()) {
        isValidPreferences = false;
        message(
          NotifyType.Error,
          "Please fill the mailing address postal code fields."
        );
      }

      if (!personalInfostorage?.contact?.salutation) {
        isValidPreferences = false;
        message(NotifyType.Error, "Please fill Salutation.");
      }
      if (!personalInfostorage?.contact?.email) {
        isValidPreferences = false;
        message(NotifyType.Error, "Please fill Email.");
      }
    }
    if (!isValidPreferences) overAllValidFlag = false;

    if (overAllValidFlag) {
      handleNextClick();
    } else {
      message(NotifyType.Error, "Please fill the mandatory fields.");
    }
  };
  function getModifiedValues<T>(original: T, current: T): Partial<T> {
    const modified: Partial<T> = {};
    for (const key in current) {
      if (current[key] !== original[key]) {
        modified[key] = current[key];
      }
    }
    return modified;
  }
  function getModifiedPreference(
    original: IlabBioPreference,
    current: IlabBioPreference
  ): IlabBioPreference | undefined {
    const modified: Partial<IlabBioPreference> = {};

    for (const key in current) {
      if (
        JSON.stringify(original[key as keyof IlabBioPreference]) !==
        JSON.stringify(current[key as keyof IlabBioPreference])
      ) {
        modified[key as keyof IlabBioPreference] =
          current[key as keyof IlabBioPreference];
      }
    }
    if (Object.keys(modified).length === 0) {
      return undefined;
    }
    return modified as IlabBioPreference;
  }
  function getModifiedSamplesAndTests(
    original: IBioSamplesAndTests[],
    current: IBioSamplesAndTests[]
  ) {
    return current
      .map((currentItem, index) => {
        const originalItem = original[index];
        const modifiedItem: any = {};
        if (currentItem.sampleCaseRowId !== originalItem?.sampleCaseRowId) {
          modifiedItem.sampleCaseRowId = currentItem.sampleCaseRowId;
        }
        Object.keys(currentItem).forEach((key) => {
          const currentValue = currentItem[key];
          const originalValue = originalItem ? originalItem[key] : undefined;
          if (currentValue !== originalValue) {
            modifiedItem[key] = currentValue;
          }
        });
        return Object.keys(modifiedItem).length > 0 ? modifiedItem : null;
      })
      .filter((item) => item !== null);
  }

  const handleBioSampleDetails = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
    type: string
  ) => {
    let name = e.target.name;
    let value: any = e.target.value;
    if (type === "number") {
      value = Math.max(0, parseInt(value));
    } else if (type === "date") {
      value = moment(value).startOf("day").format();
    }
    setBioSampleDetails((prevState) => {
      const newDetails = {
        ...prevState,
        [name]: value,
      } as IBioSampleDetails;

      let validDates = true;

      if (newDetails.samplingFromDate && newDetails.samplingToDate) {
        const fromDate = moment(newDetails.samplingFromDate);
        const toDate = moment(newDetails.samplingToDate);

        if (toDate.isBefore(fromDate)) {
          newDetails.samplingToDateErrMsg =
            "Sampling To Date must be after Sampling From Date";
          validDates = false;
        } else {
          newDetails.samplingToDateErrMsg = undefined;
        }
        if (fromDate.isAfter(toDate)) {
          newDetails.samplingFromDateErrMsg =
            "Sampling From Date must be before Sampling To Date";
          validDates = false;
        } else {
          newDetails.samplingFromDateErrMsg = undefined;
        }
      }

      setValidDates(validDates);
      setRedMessage("");
      if (bioSampleDetails?.purposeOfTestErrMsg) {
        bioSampleDetails.purposeOfTestErrMsg = "";
      }
      return newDetails;
    });
  };

  const vaccineTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const val = document
      .querySelector(`#vaccine-type-select option[value=\"${e.target.value}\"]`)
      ?.getAttribute("data-vaccine-type-id");
    let optionName: IBioVaccineName[] | undefined =
      vaccineNameOptionsBak?.filter((x) => x.vaccineType == val);
    setVaccineNameOptions(optionName);
  };
  const handleSamplesAndTests =
    (
      index: number,
      type: "number" | "string" | "date" | "datetime" | "boolean" | "checkbox"
    ) =>
    (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
      const target = e.target as HTMLInputElement;
      const newArray = samplesAndTests.map((item: IBioSamplesAndTests, i) => {
        if (index === i) {
          let value: string | number | boolean | Date = target.value;

          if (type === "number") {
            const numericValue = parseInt(target.value) || 1;
            value = Math.min(1000, Math.max(1, numericValue));
            if (target.type === "number") {
              target.value = value.toString();
            }
          } else if (type === "date") {
            value = moment(value).startOf("day").format();
          } else if (type === "datetime") {
            value = moment(value).toISOString();
          } else if (type === "boolean" || type === "checkbox") {
            value = target.checked;
          }

          return {
            ...item,
            [target.name]: value,
          };
        } else {
          return item;
        }
      });

      setSamplesAndTests(newArray);
    };

  useEffect(() => {
    setlabtestoptions([]);
  }, []);
  const handleAddTestResult = (sampleIndex: number, testLabTestID: string) => {
    debugger;
    const newResult = { ...defaultTestResult };

    setSamplesAndTests((prevSamplesAndTests) => {
      const updatedSamplesAndTests = prevSamplesAndTests.map((sample) => {
        const updatedLabBIOTestDetails = sample.labBioTestDetails.map(
          (test) => {
            if (test.labTestID === testLabTestID) {
              const updatedLabBIOTestResult = [
                ...(test.labBIOTestResult || []),
                newResult,
              ];

              return {
                ...test,
                labBIOTestResult: updatedLabBIOTestResult,
              };
            }
            return test;
          }
        );

        if (
          sample.labBioTestDetails.some(
            (test) => test.labTestID === testLabTestID
          )
        ) {
        }

        return {
          ...sample,
          labBioTestDetails: updatedLabBIOTestDetails,
        };
      });

      return updatedSamplesAndTests;
    });
  };
  const handleAddSample = () => {
    setSamplesAndTests((prevSamples) => {
      const newSample = {
        ...samplesAndTestSchema,
        id: Date.now(),
        labBioTestDetails: [],
      };
      return [...prevSamples, newSample];
    });
  };

  const handleDeleteSample = (sampleId: number | undefined) => {
    setSamplesAndTests((samples) => {
      if (samples.length > 1) {
        return samples.filter((sample) => sample.id !== sampleId);
      }
      return samples;
    });
  };

  const handleCopySample = (sampleInd: number, times: number) => {
    const sample = samplesAndTests[sampleInd];

    setSamplesAndTests((prevSamples) => {
      const newSamples = Array.from({ length: times }, () => {
        const newSample = {
          ...sample,
          id: Date.now() + Math.random(),
          disableDelete: false,
          labBioTestDetails: sample?.labBioTestDetails?.map((obj: any) => ({
            ...obj,
            disableDelete: false,
          })),
        };
        if (newSample.hasOwnProperty("rowId")) {
          delete newSample.rowId;
        }

        return newSample;
      });

      return [...prevSamples, ...newSamples];
    });
  };

  const handleSearch = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    fetchTestCodeMaster();
  };

  const fetchTestCodeMaster = async () => {
    try {
      handleLoader(true, "submit-reqq");
      const response: any = await getPshCavsTestCodeMaster({
        PurposeCode: "BIO",
        IsBiosurvillanceUser: IsBiosurvillanceUser,
      });

      if (response.data && response.data.cavs) {
        const selectedLabTitle = selectedTestLaboratory;
        let searchString: string = testDescription || "";
        const cavsData = response.data.cavs;

        const formatDescription = (description: string) => {
          return description.replace(/<i>/g, "<em>").replace(/<\/i>/g, "</em>");
        };
        if (selectedLabTitle === "All-laboratories") {
          const filteredData = cavsData.filter((item: any) =>
            item.description
              ? stripHtmlTags(item.description)
                  .toLowerCase()
                  .includes(searchString.toLowerCase())
              : false
          );

          const transformedData = filteredData.map((item: any) => ({
            description: formatDescription(item.description),
            labGroupId: item.labGroupId,
            labGroup: item.labGroup,
            labCodeMasterID: item.labCodeMasterID,
          }));
          setTestOptions(transformedData);
        } else {
          const labGroupId = labtestoptions.find(
            (item: any) => item.labGroup === selectedLabTitle
          )?.labGroupId;

          if (!labGroupId) {
            console.error(
              "Lab Master ID not found for the selected laboratory labGroup:",
              selectedLabTitle
            );
            return;
          }

          const customFilter = cavsData.filter(
            (x: any) =>
              x.labGroupId === labGroupId &&
              (x.name
                ? stripHtmlTags(x.name)
                    .toLowerCase()
                    .includes(searchString.toLowerCase())
                : false)
          );

          const transformedData = customFilter.map((item: any) => ({
            description: formatDescription(item.description),
            labGroupId: item.labGroupId,
            labGroup: item.labGroup,
            labCodeMasterID: item.labCodeMasterID,
          }));
          setTestOptions(transformedData);
        }
      } else {
        const errorMessage = "Failed to retrieve the CAVS data from the API";

        setErrorMessage(errorMessage);
      }
    } catch (error) {
      console.error("Error fetching test code master data:", error);
    } finally {
      handleLoader(false, "submit-reqq");
    }
  };
  const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleSearch(e as unknown as React.MouseEvent<HTMLButtonElement>);
  };
  const handleAddTests = () => {
    const testsToAdd = testOptions.filter(
      (test) =>
        test?.labCodeMasterID &&
        selectedTestIds.includes(test.labCodeMasterID as any)
    );

    setTestOptions((prevOptions) =>
      prevOptions.filter(
        (test) => !selectedTestIds.includes(test.labCodeMasterID as any)
      )
    );
    setSelectedTestIds([]);
    setSamplesAndTests((prevSamples: any) => {
      return prevSamples.map((prevSample: any, index: number) => {
        if (index === searchInd) {
          const currentTestDetails = prevSample.labBioTestDetails || [];
          const addedTests = currentTestDetails.map((detail: any) =>
            strippedHtmlTags(detail.testDescription)
          );

          testsToAdd.forEach((test) => {
            const strippedTestDescription = strippedHtmlTags(test.description);

            if (!addedTests.includes(strippedTestDescription)) {
              currentTestDetails.push({
                testDescription: test.description.trim(),
                laboratory: selectedTestLaboratory,
                nooftestsrequired: 1,
                noOfSamples: 1,
              });
            }
          });

          return {
            ...prevSample,
            labBioTestDetails: currentTestDetails,
          };
        } else {
          return prevSample;
        }
      });
    });
  };

  const handleRemoveTest = (
    labDetails: any,
    description: string,
    ind: number
  ) => {
    let removeTheLabID = labDetails.filter(
      (x: ILabTestDetails) => x.testDescription !== description
    );
    const newArray = samplesAndTests.map((item: IBioSamplesAndTests, i) => {
      if (ind === i) {
        return {
          ...item,
          "labBioTestDetails": removeTheLabID,
        };
      } else {
        return item;
      }
    });
    setSamplesAndTests(newArray);
  };
  useEffect(() => {}, [testOptions]);

  const toggleTestSelection = (
    labCodeMasterID: string | undefined,
    isChecked: boolean
  ) => {
    setTestOptions((prevOptions) =>
      prevOptions.map((test) =>
        test.labCodeMasterID === labCodeMasterID
          ? { ...test, isSelected: isChecked }
          : test
      )
    );

    setSelectedTestIds((prevSelected: any) => {
      if (isChecked) {
        return [...prevSelected, labCodeMasterID as string];
      } else {
        return prevSelected.filter((id: any) => id !== labCodeMasterID);
      }
    });
  };

  useEffect(() => {
    async function checkQueryString() {
      setcheckPageLoader(true);
      const applicationNum: string | null = params.get("an");
      const getUserInfo = localStorage.getItem("app-data");
      const userInfo = JSON.parse(getUserInfo || "");
      let NRIC = userInfo?.user?.idNo || "";
      const isMetadata = localStorage.getItem("ismetadata");
      const actionType: string | null = params.get("type");
      setActionType(actionType || "");
      setApplicationNum(applicationNum || "");
      let isNricRequired = 1;
      if (
        actionType === TypeOfApplicationEnum.submitresult ||
        actionType === TypeOfApplicationEnum.Acknowledge
      ) {
        isNricRequired = 0;
      }

      if (applicationNum && actionType) {
        try {
          const getBIO = await getBioApplication(
            applicationNum,
            NRIC,
            isNricRequired
          );

          if (getBIO.status === 200) {
            setShowPlaceholder(false);
            let result: IBioRequest = getBIO.data.result;

            if (result?.labBIOApplicationDetails) {
              const fromDate = result.labBIOApplicationDetails.samplingFromDate;
              const toDate = result.labBIOApplicationDetails.samplingToDate;
              if (moment(fromDate).isValid() && moment(toDate).isValid()) {
                setValidDates(true);
              } else {
                setValidDates(false);
              }
            }

            const bioDetails = result?.labBIOApplicationDetails;
            const bioPreference = result?.labBioPreference;
            const feedback = result?.submittedFeedback || 0;
            const reportgenerated = result?.isReportGenerated || 0;
            const reports = Array.isArray(result?.labReportDetails)
              ? result.labReportDetails
              : [];
            setReports(reports);
            setSubmittedFeedback(feedback);
            setreportgenerated(reportgenerated);
            const personalInfoDetails = result?.labBIOPersonalInfoDetails;
            if (isMetadata !== "1") {
              setPersonalInfo(personalInfoDetails);

              if (bioDetails && bioPreference) {
                setBioSampleDetails(bioDetails);
                setOriginalSampleDetails(bioDetails);
                setPreference(bioPreference);
                setOriginalPreference(bioPreference);

                if (result?.labBIOPersonalInfoDetails?.contact) {
                  setCustomerName(
                    result.labBIOPersonalInfoDetails.customerName
                  );

                  setSalutation(
                    result.labBIOPersonalInfoDetails.contact.salutation
                  );
                }
              }
            }

            if (result?.labBioSampleTestDetails?.length > 0) {
              localStorage.setItem(
                "choose-app",
                JSON.stringify(result.labBIOChooseAppl)
              );

              const actionedStatus = result?.actionStatus || "";
              if (actionedStatus) {
                localStorage.setItem("psh-app-status", actionedStatus);
                localStorage.setItem("psh-app-applicationNum", applicationNum);
              }

              if (
                actionType == TypeOfApplicationEnum.amendment &&
                result?.actionStatus
              ) {
                let amendCase = "";
                if (result.actionStatus === "Pending Sample(s)") {
                  amendCase = "CASE3";
                } else {
                  amendCase = "CASE4";
                }

                setAmendCase(amendCase);
              } else if (actionType === TypeOfApplicationEnum.cancel) {
                setIsCancelRequest(true);
              } else if (actionType === TypeOfApplicationEnum.submitresult) {
                setIsSubmitresultRequest(true);
              } else if (actionType === TypeOfApplicationEnum.Acknowledge) {
                setIsAcknowledge(true);
              } else if (actionType === TypeOfApplicationEnum.acknowledgement) {
                setIsAcknowledgeRequest(true);
              }

              const appNo = params.get("an") ?? "";
              if (
                appNo &&
                result?.labBIOChooseAppl?.applicationType ==
                  ApplicationTypeEnum.amendment
              ) {
                handleShowAmendmentHistory(appNo);
                setShowAmendmentHistory(true);
              }

              let samplesAndTests = result.labBioSampleTestDetails.map(
                (sample, index) => {
                  const postmartem = sample.labBioTestDetails.map(
                    (obj: any) => ({
                      isPostMartem: obj.isPostMartem,
                      labTestID: obj.labTestID,
                      testStatus: obj.testStatus,
                      isThirdPartyLab: obj.isThirdPartyLab,
                      nooftestsrequired: obj.nooftestsrequired,
                      noOfSamples: obj.noOfSamples,
                      disableDelete: true,
                      rowId: obj.rowId,
                      thirdPartyNric: obj.thirdPartyNric,
                      testDescription: obj.description || obj.testDescription,
                      labBIOTestResult: [defaultTestResult],
                    })
                  );

                  if (postmartem.length > 0) {
                    setIsPostMartem(postmartem[0].isPostMartem);
                    setlabTestID(postmartem[0].labTestID);
                    setTestStatus(postmartem[0].testStatus);
                    setisThirdPartyLab(postmartem[0].isThirdPartyLab);
                    setthirdPartyNric(postmartem[0].thirdPartyNric);
                  }
                  return {
                    ...sample,
                    id: sample.id || index + 1,
                    sampleCaseRowId: sample.rowId,
                    disableDelete: true,
                    labBioTestDetails: postmartem,
                  };
                }
              );
              if (isMetadata !== "1") {
                setSamplesAndTests(samplesAndTests);
              }
              setOriginalSamplesAndTests(samplesAndTests);
              setRejectedTestsMessage(
                generateRejectedTestsMessage(samplesAndTests)
              );
            }
          }
        } catch (error) {
          console.error(ErrMsg.InternalServerErrMsg, error);
          message(NotifyType.Error, ErrMsg.InternalServerErrMsg);
        } finally {
          setcheckPageLoader(false);
          localStorage.removeItem("ismetadata");
        }
      }
      setcheckPageLoader(false);
    }

    if (!hasFetchedInitialData) {
      checkQueryString();
      setHasFetchedInitialData(true);
    }
  }, [clinicalHistoryOptions, hasFetchedInitialData]);
  const generateRejectedTestsMessage = (samplesAndTests: any[]) => {
    let message = "Please be noted that the Test: ";
    let rejectedTests: string[] = [];

    samplesAndTests.forEach((sample: any, sampleIndex: number) => {
      const sampleMarking = sample.sampleMarking;
      sample.labBioTestDetails.forEach((test: any) => {
        if (test.testStatus === 6) {
          rejectedTests.push(
            `${test.testDescription} under Sample ${
              sampleIndex + 1
            } (${sampleMarking})`
          );
        }
      });
    });

    if (rejectedTests.length > 0) {
      message += rejectedTests.join(", ") + " is/are Rejected.";
    } else {
      message = "";
    }

    return message;
  };
  const getBIORequestSchema = (): IBioRequest => {
    try {
      delete (bioSampleDetails as any)?.vaccine_Biologics_TypeErrMsg;
      delete (bioSampleDetails as any)?.vaccineNameErrMsg;
      delete (bioSampleDetails as any)?.substrateErrMsg;
      delete (bioSampleDetails as any)?.purposeOfTestErrMsg;
      delete (bioSampleDetails as any)?.samplingFromDateErrMsg;
      delete (bioSampleDetails as any)?.samplingToDateErrMsg;
      delete (bioSampleDetails as any)?.sampledByErrMsg;
      let sampleRowId = 1;
      const updatedSamples = samplesAndTests.map((sample) => {
        let testRowId = 1;
        const updatedSample = {
          ...sample,
          rowId: sampleRowId,
          sampleRowId: sampleRowId++,
          labBioTestDetails: sample.labBioTestDetails?.map((test) => ({
            ...test,
            rowId: testRowId,
            testRowId: testRowId++,
          })),
        };
        return updatedSample;
      });

      let chooseAppMeta: IChooseApp = {
        typeOfService: "CAVS Laboratory Services",
        typeOfApplication: "BIO",
        applicationType: 0,
      };
      let personalInfo: IPersonalInfo = JSON.parse(
        localStorage.getItem("profile-info") || ""
      );
      samplesAndTests.forEach((v) => {
        delete v?.id;
        delete v?.labBioTestDetailsErrMsg;
        delete v?.sampleMarkingErrMsg;
        delete v?.disableDelete;
        if (v?.labBioTestDetails?.forEach) {
          v?.labBioTestDetails?.forEach((element: any) => {
            delete element?.disableDelete;
          });
        }
      });
      const modifiedBioDetails = originalSampleDetails
        ? getModifiedValues(originalSampleDetails, bioSampleDetails)
        : bioSampleDetails;
      const modifiedSamplesAndTests = getModifiedSamplesAndTests(
        originalSamplesAndTests,
        samplesAndTests
      );
      const modifiedPreference = getModifiedPreference(
        originalPreference,
        Preference
      );
      const filerInfo: IFilerInformation | null = getFilerInfomation();
      const meta: IBioRequest = {
        labBIOPersonalInfoDetails: personalInfo,
        labApplicationchangedDetails: modifiedBioDetails as IBioSampleDetails,
        labchangedSampleTestDetails: modifiedSamplesAndTests,
        labChangedPreference: modifiedPreference,
        labBIOChooseAppl: chooseAppMeta,
        labBIOApplicationDetails: bioSampleDetails as IBioSampleDetails,
        labBioSampleTestDetails: updatedSamples,
        labBioPreference: Preference,
        actionStatus: actionType || "",

        labBIOFilerInfoDetails: filerInfo || tempFilerInfo,
      };
      if (meta.actionStatus !== TypeOfApplicationEnum.submit) {
        meta.applicationNumber = applicationNum || "";
      }

      return meta;
    } catch (error) {
      console.error("Error in getBIORequestSchema:", error);

      throw error;
    }
  };
  const handleCopyButtonClick = (index: number) => {
    handleCopySample(index, copyCount || 1);
  };

  const handleCopyInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setCopyCount(Number(event.target.value));
  };

  const handleSamplesCountChange = (
    sampleIndex: number,
    testIndex: number,
    count: number
  ) => {
    const validatedCount = count < 1 ? 1 : count;

    setSamplesAndTests((prevSamples) => {
      return prevSamples.map((sample, sIndex) => {
        if (sIndex === sampleIndex) {
          const updatedLabBioTestDetails = sample.labBioTestDetails.map(
            (test, tIndex) => {
              if (tIndex === testIndex) {
                return {
                  ...test,
                  noOfSamples: validatedCount,
                };
              }
              return test;
            }
          );
          return {
            ...sample,
            labBioTestDetails: updatedLabBioTestDetails,
          };
        }
        return sample;
      });
    });
  };

  const handleRepeatCountChange = (
    sampleIndex: number,
    testIndex: number,
    count: number
  ) => {
    const validatedCount = count < 1 ? 1 : count;

    setRepeatCounts((prev) => ({
      ...prev,
      [sampleIndex]: {
        ...(prev[sampleIndex] || {}),
        [testIndex]: validatedCount,
      },
    }));

    setSamplesAndTests((prevSamples) => {
      return prevSamples.map((sample, sIndex) => {
        if (sIndex === sampleIndex) {
          const updatedLabBioTestDetails = sample.labBioTestDetails.map(
            (test, tIndex) => {
              if (tIndex === testIndex) {
                return {
                  ...test,
                  nooftestsrequired: validatedCount,
                };
              }
              return test;
            }
          );
          return {
            ...sample,
            labBioTestDetails: updatedLabBioTestDetails,
          };
        }
        return sample;
      });
    });
  };
  const handledPreviousClick = () => {
    navigate("/labresults-dashboard");
  };
  const handlePreviousClick = () => {
    if (
      IsAcknowledgeRequest ||
      IsAcknowledge ||
      IsSubmitresultRequest ||
      isCancelRequest ||
      amendCase
    ) {
      navigate("/lab-dashboard");
    } else {
      navigate("/choose-application");
    }
  };
  const storeInContext = async () => {
    try {
      let meta: IBioRequest = await getBIORequestSchema();

      BioMeta.updateBioMeta(meta);
    } catch (error) {
      console.error(error);
    }
  };

  const handleNextClick = async () => {
    storeInContext();
    setFormSubmitted(true);
    try {
      await getBIORequestSchema();
      localStorage.removeItem("ismetadata");
      navigate("/bio-review");
      handleLoader(true, "next-click");
      let borderDanger = document.getElementsByClassName("border-danger");
      if (borderDanger.length > 0) {
        message(NotifyType.Error, "Please fill the mandatory fields.");
        handleLoader(false, "next-click");
        return;
      }

      handleLoader(false, "next-click");
    } catch (error) {
      console.error("Error:", error);
      handleLoader(false, "next-click");
    }
  };

  const handleSaveDraftClick = async () => {
    delete (bioSampleDetails as any)?.vaccine_Biologics_TypeErrMsg;
    delete (bioSampleDetails as any)?.vaccineNameErrMsg;
    delete (bioSampleDetails as any)?.substrateErrMsg;
    delete (bioSampleDetails as any)?.purposeOfTestErrMsg;
    delete (bioSampleDetails as any)?.samplingFromDateErrMsg;
    delete (bioSampleDetails as any)?.samplingToDateErrMsg;
    delete (bioSampleDetails as any)?.sampledByErrMsg;

    try {
      handleLoader(true, "submit-req");
      const hasEmptyTests = samplesAndTests.some(
        (sample) =>
          !sample.labBioTestDetails || sample.labBioTestDetails.length === 0
      );

      if (hasEmptyTests) {
        message(NotifyType.Error, "Please add Test Information.");
        handleLoader(false, "submit-req");
        return;
      }
      let chooseAppMeta: IChooseApp = {
        typeOfApplication: "BIO",
        typeOfService: "CAVS Laboratory Services",
        applicationType: 0,
      };

      let personalInfo: IPersonalInfo = JSON.parse(
        localStorage.getItem("profile-info") || ""
      );
      const filerInfo: IFilerInformation | null = getFilerInfomation();
      const meta: IBioRequest = {
        labBIOPersonalInfoDetails: personalInfo,
        labBIOChooseAppl: chooseAppMeta,
        labBIOApplicationDetails: {
          ...bioSampleDetails,
        } as IBioSampleDetails,
        applicationNumber: applicationNum,

        labBioSampleTestDetails: samplesAndTests.map((sample) => {
          return {
            ...sample,
            labBioTestDetails: sample.labBioTestDetails.map((test: any) => ({
              ...test,
              testDescription: stripHtmlTags(test.testDescription),
            })),
          };
        }),
        labBioPreference: Preference,
        labBIOFilerInfoDetails: filerInfo || tempFilerInfo,
      };

      if (actionType === TypeOfApplicationEnum.submit) {
        delete meta.applicationNumber;
      }
      if (meta.labBioSampleTestDetails) {
        meta.labBioSampleTestDetails.forEach((v: any) => {
          delete v?.id;
          delete v?.labBioTestDetailsErrMsg;

          delete v?.sampleMarkingErrMsg;
          delete v?.disableDelete;
          if (v?.labBioTestDetails?.forEach) {
            v?.labBioTestDetails?.forEach((element: any) => {
              delete element?.disableDelete;
            });
          }
        });
      }

      const response1 = await SaveBIODraftApplications(meta);

      if (response1.status === 200) {
        const acknowledgmentNumberMatch = response1.data?.match(
          /"BIODraftApplicationNumber":"(\w+)"/
        );

        const acknowledgmentNumber = acknowledgmentNumberMatch
          ? acknowledgmentNumberMatch[1]
          : undefined;
        setApplicationNum(acknowledgmentNumber || "");
        if (actionType === TypeOfApplicationEnum.submit) {
          setActionType("Draft");
        }

        message(
          NotifyType.Success,
          acknowledgmentNumber
            ? `Draft Saved Successfully`
            : "Draft Saved Successfully"
        );

        setAcknowledgmentMessage(
          acknowledgmentNumber ? `${acknowledgmentNumber}` : ""
        );

        localStorage.removeItem("psh-app-status");
        localStorage.removeItem("ismetadata");
      } else {
        message(NotifyType.Error, "Issue on the request submission.");
        handleLoader(false, "submit-req");
      }
    } catch (error) {
      console.error(ErrMsg.InternalServerErrMsg, error);
      message(NotifyType.Error, ErrMsg.InternalServerErrMsg);
    } finally {
      handleLoader(false, "");
    }
  };

  const validateSamplesAndTests = (
    samplesAndTests: any[],
    customerNRIC: string
  ) => {
    let isValidSampleAndTests = true;
    let missingFields: string[] = [];

    const validatedSamples = samplesAndTests.map((item: any) => {
      const filteredTests =
        item.labBioTestDetails?.filter((test: any) => {
          const isValidTest =
            test.isThirdPartyLab === 1 &&
            test.thirdPartyNric === customerNRIC &&
            test.rowId === testRowId &&
            (test.testStatus === null || test.testStatus !== 8);
          return isValidTest;
        }) || [];

      filteredTests.forEach((test: any) => {
        const isPostMartem = test.isPostMartem === 1;

        const fieldsToValidate = isPostMartem
          ? postMartemFields
          : Object.values(ResultMandatoryFields);

        if (test.labBIOTestResult && test.labBIOTestResult.length > 0) {
          test.labBIOTestResult = test.labBIOTestResult.map(
            (result: any, resultIndex: number) => {
              let isValidResult = true;

              fieldsToValidate.forEach((field) => {
                const fieldValue = result[field];

                if (
                  fieldValue === undefined ||
                  fieldValue === null ||
                  fieldValue === ""
                ) {
                  isValidSampleAndTests = false;
                  isValidResult = false;
                  missingFields.push(field);

                  result = {
                    ...result,
                    [`${field}ErrMsg`]: `Please fill ${field}.`,
                  };
                } else {
                  result = {
                    ...result,
                    [`${field}ErrMsg`]: "",
                  };
                }
              });

              return result;
            }
          );
        }
      });

      return item;
    });

    return { isValidSampleAndTests, validatedSamples, missingFields };
  };
  const handledSaveResultClick = async () => {
    try {
      handleLoader(true, "submit-req");

      const { isValidSampleAndTests, validatedSamples, missingFields } =
        validateSamplesAndTests(samplesAndTests, customerNRIC);

      if (!isValidSampleAndTests) {
        setSamplesAndTests(validatedSamples);
        message(NotifyType.Error, "Please fill the mandatory fields.");
        handleLoader(false, "");
        return;
      }

      const applicationNum = params.get("an") ?? "";
      const dataToSubmit = {
        applicationNumber: applicationNum,
        labResultRequests: samplesAndTests.flatMap((sample) =>
          sample.labBioTestDetails
            .filter((test) => {
              const isValidTest =
                test.isThirdPartyLab === 1 &&
                test.thirdPartyNric === customerNRIC &&
                test.rowId === testRowId &&
                (test.testStatus === null || test.testStatus !== 8);

              return test.testDescription !== "" && isValidTest;
            })
            .flatMap((test) =>
              (test.labBIOTestResult ?? []).map((result, resultIndex) => ({
                labTestID: test.labTestID,
                testDescription: stripHtmlTags(test.testDescription),
                ResultDocuments: test.ResultDocuments ?? [],
                ResultDocumentName: test.ResultDocumentName ?? "",
                isAdditionalResult: resultIndex === 0 ? 0 : 1,
                ...mergeWithDefaults(result),
              }))
            )
        ),
      };

      const response = await saveResultRequest(dataToSubmit);

      if (response?.status === 200) {
        message(NotifyType.Success, "Results Saved Successfully");

        localStorage.removeItem("psh-app-status");
        localStorage.removeItem("ismetadata");
        setTimeout(() => {
          navigate("/");
        }, 3000);
      } else {
        message(NotifyType.Error, "Issue on the request submission.");
      }
    } catch (error) {
      console.error(ErrMsg.InternalServerErrMsg, error);
      message(NotifyType.Error, ErrMsg.InternalServerErrMsg);
    } finally {
      handleLoader(false, "");
    }
  };

  const handleACKResultClick = async () => {
    try {
      handleLoader(true, "submit-req");
      const newArray = samplesAndTests.map((sample: any) => {
        sample.labBioTestDetails.forEach((test: any) => {
          delete test.labBioTestResult;
        });
        return sample;
      });
      setSamplesAndTests(newArray);
      const applicationNum = params.get("an") ?? "";
      const dataToSubmit = {
        applicationNumber: applicationNum,
        labResultRequests: samplesAndTests.flatMap((sample) =>
          sample.labBioTestDetails
            .filter(
              (test) =>
                test.testDescription !== "" &&
                test.isThirdPartyLab === 1 &&
                test.rowId === testRowId &&
                test.thirdPartyNric === customerNRIC &&
                test.testStatus !== 8
            )
            .map((test) => ({
              labTestID: test.labTestID,
              testDescription: test.testDescription,
              laboratory: test.laboratory,
              TestStatus: 7,
            }))
        ),
      };
      if (dataToSubmit.labResultRequests.length === 0) {
        message(NotifyType.Warning, "No tests available for submission.");
        return;
      }

      const response = await saveAckRequest(dataToSubmit);
      if (response?.status === 200) {
        message(NotifyType.Success, "Request Saved Successfully");
        localStorage.removeItem("psh-app-applicationNum");
        localStorage.removeItem("ismetadata");
        localStorage.removeItem("psh-app-status");
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set("type", "submitresult");
        window.location.href = currentUrl.toString();
      } else {
        message(NotifyType.Error, "Issue with the request submission.");
      }
    } catch (error) {
      console.error(ErrMsg.InternalServerErrMsg, error);
      message(NotifyType.Error, ErrMsg.InternalServerErrMsg);
    } finally {
      handleLoader(false, "");
    }
  };
  const cancelRequest = async () => {
    delete (bioSampleDetails as any)?.vaccine_Biologics_TypeErrMsg;
    delete (bioSampleDetails as any)?.vaccineNameErrMsg;
    delete (bioSampleDetails as any)?.substrateErrMsg;
    delete (bioSampleDetails as any)?.purposeOfTestErrMsg;
    delete (bioSampleDetails as any)?.samplingFromDateErrMsg;
    delete (bioSampleDetails as any)?.samplingToDateErrMsg;
    delete (bioSampleDetails as any)?.sampledByErrMsg;

    try {
      setCancelCommentsErrMsg("");
      if (cancelComments) {
        handleLoader(true, "cancel-request-btn");

        let chooseAppMeta: IChooseApp = {
          typeOfApplication: "BIO",
          typeOfService: "CAVS Laboratory Services",
          applicationType: 0,
        };

        let personalInfo: IPersonalInfo = JSON.parse(
          localStorage.getItem("profile-info") || ""
        );
        const applicationNum: string = params.get("an") ?? "";
        const filerInfo: IFilerInformation | null = getFilerInfomation();

        const meta: IBioRequest = {
          labBIOPersonalInfoDetails: personalInfo,
          labBIOChooseAppl: chooseAppMeta,
          labBIOApplicationDetails: {
            ...bioSampleDetails,
          } as IBioSampleDetails,
          labBioSampleTestDetails: samplesAndTests,
          labBioPreference: Preference,
          applicationNumber: applicationNum,
          labBioApplicationStatus: defBIOCancelAppStatus,
          labBIOFilerInfoDetails: filerInfo || tempFilerInfo,
          reasonForCancellation: cancelComments,
        };

        if (meta.labBioSampleTestDetails) {
          meta.labBioSampleTestDetails.forEach((v: any) => {
            delete v?.id;
            delete v?.labBioTestDetailsErrMsg;

            delete v?.sampleMarkingErrMsg;
            delete v?.disableDelete;
            if (v?.labBioTestDetails?.forEach) {
              v?.labBioTestDetails?.forEach((element: any) => {
                delete element?.disableDelete;
              });
            }
          });
        }

        let response1 = await saveBIOLabCancellation(meta);
        if (response1.status === 200) {
          const acknowledgmentNumberMatch = response1.data?.match(
            /"CAVS_AQUACancelApplicationNumber":"(\w+)"/
          );

          const acknowledgmentNumber = acknowledgmentNumberMatch
            ? acknowledgmentNumberMatch[1]
            : undefined;
          message(
            NotifyType.Success,
            `Cancellation Request Submitted Successfully. Acknowledgment Number: ${acknowledgmentNumber}`
          );
          setcancelMessage(
            acknowledgmentNumber ? `${acknowledgmentNumber}` : ""
          );

          localStorage.removeItem("choose-app");
          setCancelButtonHidden(true);
          setTimeout(() => {
            navigate("/lab-dashboard", { state: { acknowledgmentNumber } });
          }, 3000);
        } else {
          message(NotifyType.Error, "Issue on the request submission.");
        }
      } else {
        setCancelCommentsErrMsg("Please fill Cancellation Comments");
        message(NotifyType.Error, "Please fill the mandatory fields.");
      }
      handleLoader(false, "cancel-request-btn");
    } catch (ex) {
      console.error(ex);
      handleLoader(false, "cancel-request-btn");
    }
  };

  let bannerName = "Application for Laboratory Testing";
  if (isCancelRequest) {
    bannerName = "Submission of Cancellation Request";
  } else if (amendCase) {
    bannerName = "Submission of Amendment Request";
  } else if (IsAcknowledge) {
    bannerName = "Acknowledge Test";
  } else if (IsSubmitresultRequest) {
    bannerName = "Submission of Test Result";
  }
  return (
    <>
      <Header />
      <Container>
        <div className="h1Lab">{bannerName} </div>
        <Stepwizard
          currentStep={stepWizardConfig.currentStep}
          steps={stepWizardConfig.steps}
        />
        {pageLoader || checkpageLoader ? (
          <Loader />
        ) : (
          <div className="row setup-content" id="step-1">
            <div className="col-md-12">
              <div className="tab-wizard-content">
                {acknowledgmentMessage && (
                  <div className="info-content">
                    <div className="att">
                      <h3>Attention</h3>
                      <br />
                      <p className="attention">
                        {">"} Application has been successfully Saved as Draft.
                        Service Acknowledgement Number: &nbsp;
                        {acknowledgmentMessage ? acknowledgmentMessage : ""}
                      </p>
                    </div>
                  </div>
                )}

                {RedMessage && (
                  <div className="info-content">
                    <div className="att">
                      <br />
                      <div className="text-danger">
                        <center>{RedMessage}</center>
                      </div>
                    </div>
                  </div>
                )}
                {cancelMessage && (
                  <div className="info-content">
                    <div className="att">
                      <h3>Attention</h3>
                      <br />
                      <p className="attention">
                        {">"} Cancellation Request Submitted Successfully.
                        Service Acknowledgement Number: &nbsp;
                        {cancelMessage ? cancelMessage : ""}
                      </p>
                    </div>
                  </div>
                )}
                {applicationNum && !cancelMessage && (
                  <div className="info-content">
                    <div className="att">
                      <h2>
                        <center>Application Number: {applicationNum}</center>
                      </h2>
                    </div>
                  </div>
                )}
                {!IsSubmitresultRequest && !IsAcknowledge ? (
                  <PersonalInformation
                    profileInfo={personalInfo}
                    onModeOfPaymentChange={setModeOfPayment}
                  />
                ) : null}

                {IsAcknowledgeRequest ? (
                  <div className="personal-info">
                    <div className="clonable-block" data-toggle="cloner">
                      <div className="clonable" data-clone-number="1">
                        <div className="info-heading">
                          <table className="table table-bordered table-hover">
                            <thead>
                              <tr>
                                <th className="grid-header">Report Name</th>
                                <th className="grid-header">Report Type</th>
                                <th className="grid-header">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {reports
                                .filter((report) => {
                                  const actionedStatus =
                                    localStorage.getItem("psh-app-status");
                                  if (report.reportData === null) return false;
                                  if (report.reportType === 5) {
                                    return (
                                      actionedStatus !== "Pending Sample(s)" &&
                                      actionedStatus !== "Sample(s) Received"
                                    );
                                  }
                                  return report.reportType === 3;
                                })
                                .map((report, index) => (
                                  <tr key={report.reportName}>
                                    <td>
                                      <center>
                                        <h6>{report.reportName}</h6>
                                      </center>
                                    </td>
                                    <td>
                                      <h6>
                                        {renderReportType(report.reportType)}
                                      </h6>
                                    </td>
                                    <td>
                                      <button
                                        className="ACKFile"
                                        onClick={() =>
                                          handleDownload(
                                            report.reportName,
                                            report.reportData,
                                            index,
                                            reports.length,
                                            applicationNum 
                                          )
                                        }
                                      >
                                        Download
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
                <div className="info-content">
                  <div className="attt">
                    <h2>
                      <center>
                        <h2>Purpose Code: BIO</h2>
                      </center>
                    </h2>
                  </div>
                </div>

                <Tabs
                  className="samples-and-tests-cavs"
                  activeKey={activeTab.toString()}
                  onSelect={(k: string | null) => {
                    if (k) {
                      setActiveTab(parseInt(k));
                    }
                  }}
                  id="controlled-tab-example"
                >
                  {!(IsAcknowledge || IsSubmitresultRequest) && (
                    <Tab eventKey={1} title="Sample Details">
                      {pageLoader || checkpageLoader ? (
                        <Loader />
                      ) : (
                        <div className="personal-info">
                          <div className="info-heading">
                            <h2 className="pb-0">
                              Sample Details <center></center>
                            </h2>
                          </div>
                          <div className="info-content">
                            <div className="row">
                              <div className="row">
                                <div className="col-lg-6">
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <label
                                        className="form-check-label"
                                        htmlFor=""
                                      >
                                        Purpose of Application
                                        <span className="star-red">*</span>
                                      </label>
                                    </div>
                                    <div className="col-lg-6">
                                      <select
                                        className={`form-select ${
                                          bioSampleDetails?.purposeOfTestErrMsg
                                            ? "border-danger op05"
                                            : ""
                                        }`}
                                        aria-label="Default select example"
                                        name="purposeOfTest"
                                        onChange={(e) =>
                                          handleBioSampleDetails(e, "number")
                                        }
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest ||
                                          modeOfPayment === "Biosurveillance"
                                        }
                                        value={
                                          modeOfPayment === "Biosurveillance"
                                            ? 1
                                            : bioSampleDetails?.purposeOfTest
                                        }
                                      >
                                        <option selected>-- Select --</option>
                                        {purposeOfTestOptions &&
                                          purposeOfTestOptions
                                            .filter((x) =>
                                              modeOfPayment ===
                                              "Biosurveillance"
                                                ? x.id === 1
                                                : x.name !== "Biosurveillance"
                                            )
                                            .map((x) => (
                                              <option key={x.id} value={x.id}>
                                                {x.name}
                                              </option>
                                            ))}
                                      </select>
                                      {bioSampleDetails?.purposeOfTestErrMsg && (
                                        <div className="error-message">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          Please fill Purpose of Application.
                                        </div>
                                      )}

                                      {bioSampleDetails?.purposeOfTest ===
                                        7 && (
                                        <div className="col-lg-12 mt-2">
                                          <input
                                            type="text"
                                            className={`form-control ${
                                              !bioSampleDetails?.otherPurposeOfTest
                                                ? "border-danger op05"
                                                : ""
                                            }`}
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                            placeholder={
                                              showPlaceholder
                                                ? "Enter Purpose of Application"
                                                : ""
                                            }
                                            name="otherPurposeOfTest"
                                            value={
                                              bioSampleDetails?.otherPurposeOfTest
                                            }
                                            onChange={(e) =>
                                              handleBioSampleDetails(
                                                e,
                                                "string"
                                              )
                                            }
                                          />
                                          {bioSampleDetails?.otherPurposeOfTestErrMsg && (
                                            <div className="error-message">
                                              <FontAwesomeIcon
                                                className="me-1"
                                                icon={faCircleExclamation}
                                              />
                                              {
                                                bioSampleDetails.otherPurposeOfTestErrMsg
                                              }
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <label htmlFor="crossReference">
                                        Cross Reference
                                      </label>
                                    </div>
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        id="crossReference"
                                        name="crossReference"
                                        value={bioSampleDetails?.crossReference}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                        maxLength={100}
                                        className="form-control"
                                        onChange={(e) =>
                                          handleBioSampleDetails(e, "string")
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                                {/* <div className="col-lg-6">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <label
                                      className="form-check-label"
                                      htmlFor="samples"
                                    >
                                      Sample(s) to be collected or submitted?
                                    </label>
                                  </div>
                                  <div className="col-lg-6">
                                    <select
                                      title="samples"
                                      name="samplesCollectedOrSubmitted"
                                      className={`form-control ${
                                        bioSampleDetails?.samplesCollectedOrSubmittedErrMsg
                                          ? "border-danger op05"
                                          : ""
                                      }`}
                                      value={
                                        bioSampleDetails?.samplesCollectedOrSubmitted
                                      }
                                      disabled
                                    >
                                      <option value="Tobecollected">
                                        To be collected
                                      </option>
                                      <option value="Tobesubmitted">
                                        To be submitted
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div> 
                              {/* <div className="col-lg-6">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <label
                                      className="form-check-label"
                                      htmlFor="samples"
                                    >
                                      Sample(s) to be collected or submitted?
                                    </label>
                                  </div>
                                  <div className="col-lg-6">
                                    <select
                                      title="samples"
                                      name="samplesCollectedOrSubmitted"
                                      className={`form-control ${
                                        bioSampleDetails?.samplesCollectedOrSubmittedErrMsg
                                          ? "border-danger op05"
                                          : ""
                                      }`}
                                      value={
                                        bioSampleDetails?.samplesCollectedOrSubmitted
                                      }
                                      disabled
                                    >
                                      <option value="Tobecollected">
                                        To be collected
                                      </option>
                                      <option value="Tobesubmitted">
                                        To be submitted
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div> */}
                              </div>
                              {/* {bioSampleDetails?.samplesCollectedOrSubmitted ===
                              "Tobecollected" && (
                              <div className="row mt-2">
                                <div className="col-lg-6">
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <label
                                        className="form-check-label"
                                        htmlFor="courierName"
                                      >
                                        Courier Name
                                      </label>
                                    </div>
                                    <div className="col-lg-6">
                                      <select
                                        title="courierName"
                                        name="courierName"
                                        className="form-control"
                                        value={bioSampleDetails?.courierName}
                                        disabled={
                                          amendCase == "CASE4" ||
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsSubmitresultRequest
                                        }
                                        onChange={(e) =>
                                          handleBioSampleDetails(e, "string")
                                        }
                                      >
                                        {" "}
                                        <option value="" disabled hidden>
                                          Select a courier
                                        </option>
                                        <option value="courierOption1">
                                          Courier Option 1
                                        </option>
                                        <option value="courierOption2">
                                          Courier Option 2
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="row mt-2 mt-lg-0">
                                    <div className="col-lg-6">
                                      <label
                                        className="form-check-label"
                                        htmlFor="courierTrackingNumber"
                                      >
                                        Courier tracking number
                                      </label>
                                    </div>
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        id="courierTrackingNumber"
                                        name="courierTrackingNo"
                                        className="form-control"
                                        value={
                                          bioSampleDetails?.courierTrackingNo
                                        }
                                        disabled={
                                          amendCase == "CASE4" ||
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsSubmitresultRequest
                                        }
                                        onChange={(e) =>
                                          handleBioSampleDetails(e, "string")
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )} */}
                              {modeOfPayment === "Biosurveillance" && (
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="row">
                                      <div className="col-lg-6 mt-2">
                                        <label
                                          className="form-check-label"
                                          htmlFor=""
                                        >
                                          Biosurveillance Program
                                          <span className="star-red">*</span>
                                        </label>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="col-lg-12 mt-2">
                                          <select
                                            className={`form-select ${
                                              bioSampleDetails?.bioSurveillanceProgramErrMsg
                                                ? "border-danger op05"
                                                : ""
                                            }`}
                                            aria-label="Default select example"
                                            name="bioSurveillanceProgram"
                                            value={
                                              bioSampleDetails?.bioSurveillanceProgram
                                            }
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                            onChange={(e) =>
                                              handleBioSampleDetails(
                                                e,
                                                "string"
                                              )
                                            }
                                          >
                                            <option selected>
                                              -- Select --
                                            </option>
                                            {bioSurveillanceProgramsOptions &&
                                              bioSurveillanceProgramsOptions.map(
                                                (x) => {
                                                  return (
                                                    <option value={x.label}>
                                                      {x.label}
                                                    </option>
                                                  );
                                                }
                                              )}
                                          </select>
                                          {bioSampleDetails?.bioSurveillanceProgramErrMsg && (
                                            <div className="error-message">
                                              <FontAwesomeIcon
                                                className="me-1"
                                                icon={faCircleExclamation}
                                              />
                                              Please select Biosurveillance
                                              Program.
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              <div className="row mt-2">
                                <div className="col-lg-3">
                                  <label
                                    className="form-check-label"
                                    htmlFor=""
                                  >
                                    Country of Origin
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <div className="rs-container">
                                    <Select
                                      classNamePrefix="rs"
                                      options={countryOptions}
                                      value={countryOptions.find(
                                          (option) => option.value === bioSampleDetails?.countryOfOrigin
                                      )}
                                        onChange={handleSelectChange("countryOfOrigin")}
                                      isDisabled={
                                        isCancelRequest ||
                                        IsAcknowledgeRequest ||
                                        IsAcknowledge ||
                                        IsSubmitresultRequest
                                      }
                                      placeholder="Select a country"
                                        isSearchable
                                        isClearable={false}

                                        /* --- FIXED DROPDOWN BEHAVIOR --- */
                                        
                                        maxMenuHeight={260}                                        
                                        menuPlacement="auto"                                                                            
                                        filterOption={(option, inputValue) =>
                                          option.label.toLowerCase().includes(inputValue.toLowerCase())
                                        }
                                      />

                                    </div>
                                </div>
                                <div className="col-lg-3">
                                  <label
                                    className="form-check-label"
                                    htmlFor=""
                                  >
                                    Date of Import
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <div
                                    className="input-group date"
                                    id="datepicker"
                                  >
                                    <input
                                      type="date"
                                      className={`form-control`}
                                      name="dateOfImport"
                                      value={
                                        bioSampleDetails?.dateOfImport
                                          ? moment(
                                              bioSampleDetails?.dateOfImport
                                            ).format("YYYY-MM-DD")
                                          : ""
                                      }
                                      disabled={
                                        isCancelRequest ||
                                        IsAcknowledgeRequest ||
                                        IsAcknowledge ||
                                        IsSubmitresultRequest
                                      }
                                      onChange={(e) =>
                                        handleBioSampleDetails(e, "date")
                                      }
                                    />
                                  </div>
                                </div>

                                <div className="row-mt-2">
                                  <div className="row">
                                    <div className="col-lg-3 mt-2">
                                      <label
                                        className="form-check-label"
                                        htmlFor=""
                                      >
                                        Sampling From Date{" "}
                                        <span className="star-red">*</span>
                                      </label>
                                    </div>
                                    <div className="col-lg-3 mt-2">
                                      <input
                                        type="datetime-local"
                                        className={`form-control ${
                                          bioSampleDetails?.samplingToDate &&
                                          moment(
                                            bioSampleDetails?.samplingToDate
                                          ).isBefore(
                                            moment(
                                              bioSampleDetails?.samplingFromDate
                                            )
                                          )
                                            ? "border-danger"
                                            : ""
                                        }`}
                                        name="samplingFromDate"
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                        value={
                                          bioSampleDetails?.samplingFromDate
                                            ? moment(
                                                bioSampleDetails?.samplingFromDate
                                              ).format("YYYY-MM-DDTHH:mm")
                                            : ""
                                        }
                                        onChange={(e) =>
                                          handleBioSampleDetails(
                                            e,
                                            "datetime-local"
                                          )
                                        }
                                        /*max={
                                          bioSampleDetails?.samplingToDate
                                            ? moment(
                                                bioSampleDetails?.samplingToDate
                                              ).format("YYYY-MM-DDTHH:mm")
                                            : maxDateTime
                                        }*/
                                      />
                                      {bioSampleDetails?.samplingFromDateErrMsg && (
                                        <div className="error-message">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          {
                                            bioSampleDetails?.samplingFromDateErrMsg
                                          }
                                        </div>
                                      )}
                                    </div>

                                    <div className="col-lg-3 mt-2">
                                      <label
                                        className="form-check-label"
                                        htmlFor="courierTrackingNo"
                                      >
                                        Sampling To Date{" "}
                                        <span className="star-red">*</span>
                                      </label>
                                    </div>
                                    <div className="col-lg-3 mt-2">
                                      <input
                                        type="datetime-local"
                                        className={`form-control ${
                                          bioSampleDetails?.samplingFromDate &&
                                          moment(
                                            bioSampleDetails?.samplingToDate
                                          ).isBefore(
                                            moment(
                                              bioSampleDetails?.samplingFromDate
                                            )
                                          )
                                            ? "border-danger"
                                            : ""
                                        }`}
                                        name="samplingToDate"
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                        value={
                                          bioSampleDetails?.samplingToDate
                                            ? moment(
                                                bioSampleDetails.samplingToDate
                                              ).format("YYYY-MM-DDTHH:mm")
                                            : ""
                                        }
                                        onChange={(e) =>
                                          handleBioSampleDetails(
                                            e,
                                            "datetime-local"
                                          )
                                        }
                                        min={
                                          bioSampleDetails?.samplingFromDate
                                            ? moment(
                                                bioSampleDetails?.samplingFromDate
                                              ).format("YYYY-MM-DDTHH:mm")
                                            : ""
                                        }
                                      />
                                      {bioSampleDetails?.samplingToDateErrMsg && (
                                        <div className="error-message">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          {
                                            bioSampleDetails?.samplingToDateErrMsg
                                          }
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="row mt-2">
                              <div className="row">
                                <div className="col-lg-3">
                                  <label htmlFor="sampledBy">
                                    Sampled By{" "}
                                    <span className="star-red">*</span>
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <input
                                    type="text"
                                    id="sampledBy"
                                    name="sampledBy"
                                    value={bioSampleDetails?.sampledBy}
                                    disabled={
                                      isCancelRequest ||
                                      IsAcknowledgeRequest ||
                                      IsAcknowledge ||
                                      IsSubmitresultRequest
                                    }
                                    className="form-control"
                                    maxLength={100}
                                    onChange={(e) =>
                                      handleBioSampleDetails(e, "string")
                                    }
                                  />
                                  {bioSampleDetails?.sampledByErrMsg && (
                                    <div className="error-message">
                                      <FontAwesomeIcon
                                        className="me-1"
                                        icon={faCircleExclamation}
                                      />
                                      Please Fill Sampled By.
                                    </div>
                                  )}
                                </div>

                                <div className="col-lg-3">
                                  <label
                                    className="form-check-label"
                                    htmlFor=""
                                  >
                                    Import Permit/Licence No.
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    name="importPermitNo"
                                    maxLength={20}
                                    value={bioSampleDetails?.importPermitNo}
                                    disabled={
                                      isCancelRequest ||
                                      IsAcknowledgeRequest ||
                                      IsAcknowledge ||
                                      IsSubmitresultRequest
                                    }
                                    onChange={(e) =>
                                      handleBioSampleDetails(e, "string")
                                    }
                                  />
                                </div>
                              </div>

                              <div className="row mt-2">
                                <div className="col-lg-3">
                                  <label
                                    className="form-check-label"
                                    htmlFor=""
                                  >
                                    No. of Vials Submitted
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    name="noOfVialsSubmitted"
                                    disabled={
                                      isCancelRequest ||
                                      IsAcknowledgeRequest ||
                                      IsAcknowledge ||
                                      IsSubmitresultRequest
                                    }
                                    value={bioSampleDetails?.noOfVialsSubmitted}
                                    onChange={(e) =>
                                      handleBioSampleDetails(e, "string")
                                    }
                                    maxLength={15}
                                  />
                                </div>
                                <div className="col-lg-3">
                                  <label
                                    className="form-check-label"
                                    htmlFor=""
                                  >
                                    Doses/Vial
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    name="dosesVial"
                                    value={bioSampleDetails?.dosesVial}
                                    disabled={
                                      isCancelRequest ||
                                      IsAcknowledgeRequest ||
                                      IsAcknowledge ||
                                      IsSubmitresultRequest
                                    }
                                    maxLength={30}
                                    onChange={(e) =>
                                      handleBioSampleDetails(e, "string")
                                    }
                                  />
                                </div>
                              </div>

                              <div className="row mt-2">
                                <div className="col-lg-3">
                                  <label
                                    className="form-check-label"
                                    htmlFor=""
                                  >
                                    Vaccine/Biologics Type
                                    <span className="star-red">*</span>
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <select
                                    className={`form-select ${
                                      bioSampleDetails?.vaccine_Biologics_TypeErrMsg
                                        ? "border-danger op05"
                                        : ""
                                    }`}
                                    aria-label="Default select example"
                                    name="vaccine_Biologics_Type"
                                    id="vaccine-type-select"
                                    disabled={
                                      isCancelRequest ||
                                      IsAcknowledgeRequest ||
                                      IsAcknowledge ||
                                      IsSubmitresultRequest
                                    }
                                    value={
                                      bioSampleDetails?.vaccine_Biologics_Type
                                    }
                                    onChange={(e) => {
                                      handleBioSampleDetails(e, "string");
                                      vaccineTypeChange(e);
                                    }}
                                  >
                                    <option selected>-- Select --</option>
                                    {vaccineTypeOptions &&
                                      vaccineTypeOptions.map((x) => {
                                        return (
                                          <option
                                            data-vaccine-type-id={x.id}
                                            value={x.description}
                                          >
                                            {x.description}
                                          </option>
                                        );
                                      })}
                                  </select>
                                  {bioSampleDetails?.vaccine_Biologics_TypeErrMsg && (
                                    <div className="error-message">
                                      <FontAwesomeIcon
                                        className="me-1"
                                        icon={faCircleExclamation}
                                      />
                                      Please fill Vaccine Type
                                    </div>
                                  )}
                                </div>
                                <div className="col-lg-3">
                                  <label
                                    className="form-check-label"
                                    htmlFor=""
                                  >
                                    Diluent Batch No.
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="diluent_Batch_No"
                                    maxLength={20}
                                    value={bioSampleDetails?.diluent_Batch_No}
                                    disabled={
                                      isCancelRequest ||
                                      IsAcknowledgeRequest ||
                                      IsAcknowledge ||
                                      IsSubmitresultRequest
                                    }
                                    onChange={(e) =>
                                      handleBioSampleDetails(e, "string")
                                    }
                                    placeholder=""
                                  />
                                </div>
                              </div>
                              <div className="row mt-2">
                                <div className="col-lg-3">
                                  <label
                                    className="form-check-label"
                                    htmlFor=""
                                  >
                                    Vaccine Name
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <select
                                    // className={`form-select ${
                                    //   bioSampleDetails?.vaccineNameErrMsg
                                    //     ? "border-danger op05"
                                    //     : ""
                                    // }`}
                                    className="form-select"
                                    aria-label="Default select example"
                                    name="vaccineName"
                                    value={bioSampleDetails?.vaccineName}
                                    disabled={
                                      isCancelRequest ||
                                      IsAcknowledgeRequest ||
                                      IsAcknowledge ||
                                      IsSubmitresultRequest
                                    }
                                    onChange={(e) =>
                                      handleBioSampleDetails(e, "string")
                                    }
                                  >
                                    <option selected>-- Select --</option>
                                    {vaccineNameOptions &&
                                      vaccineNameOptions.map((x) => {
                                        return (
                                          <option value={x.vaccineName}>
                                            {x.vaccineName}
                                          </option>
                                        );
                                      })}
                                  </select>
                                  {/* {bioSampleDetails?.vaccineNameErrMsg && (
                                    <div className="error-message">
                                      <FontAwesomeIcon
                                        className="me-1"
                                        icon={faCircleExclamation}
                                      />
                                      Please fill Vaccine Name.
                                    </div>
                                  )} */}
                                </div>
                                <div className="col-lg-3">
                                  <label
                                    className="form-check-label"
                                    htmlFor=""
                                  >
                                    Diluent Expiry Date
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <div
                                    className="input-group date"
                                    id="datepicker"
                                  >
                                    <input
                                      type="date"
                                      className={`form-control`}
                                      name="diluentExpiryDate"
                                      disabled={
                                        isCancelRequest ||
                                        IsAcknowledgeRequest ||
                                        IsAcknowledge ||
                                        IsSubmitresultRequest
                                      }
                                      value={
                                        bioSampleDetails?.diluentExpiryDate
                                          ? moment(
                                              bioSampleDetails?.diluentExpiryDate
                                            ).format("YYYY-MM-DD")
                                          : ""
                                      }
                                      onChange={(e) =>
                                        handleBioSampleDetails(e, "date")
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="row-mt-2">
                                  <div className="row">
                                    <div className="col-lg-3 mt-2">
                                      <label
                                        className="form-check-label"
                                        htmlFor="countryOfDestination"
                                      >
                                        Country of Destination{" "}
                                        {bioSampleDetails?.purposeOfTest ===
                                          4 && (
                                          <span className="star-red">*</span>
                                        )}
                                      </label>
                                    </div>
                                    <div className="col-lg-3 mt-2">
                                      <div className="rs-container">
                                    <Select
                                      classNamePrefix="rs"
                                      options={countryOptions}
                                      value={countryOptions.find(
                                        (option) =>
                                          option.value ===
                                          bioSampleDetails?.countryOfDestination
                                      )}
                                      onChange={handleSelectChange(
                                        "countryOfDestination"
                                      )}
                                      isDisabled={
                                        isCancelRequest ||
                                        IsAcknowledgeRequest ||
                                        IsAcknowledge ||
                                        IsSubmitresultRequest
                                      }
                                      placeholder="Select a country"
                                      isSearchable={true}
                                      isClearable={false}    
                                       /* --- FIXED DROPDOWN BEHAVIOR --- */
                                     
                                      maxMenuHeight={260}
                                      menuPlacement="auto" 
                                      filterOption={(option, inputValue) => {
                                        return option.label.toLowerCase().includes(inputValue.toLowerCase());
                                      }}
                                    />
                                    {bioSampleDetails?.exportercountryOfDestinationErrMsg && (
                                      <div className="error-message">
                                        <FontAwesomeIcon
                                          className="me-1"
                                          icon={faCircleExclamation}
                                        />
                                        Please fill Country of Destination.
                                      </div>
                                    )}
                                    </div>
                                    </div>

                                    <div className="col-lg-3 mt-2">
                                      <label
                                        className="form-check-label"
                                        htmlFor="dateToBeExported"
                                      >
                                        Date to be Exported
                                        {bioSampleDetails?.purposeOfTest ===
                                      4 && <span className="star-red">*</span>}
                                      </label>
                                    </div>
                                    <div className="col-lg-3 mt-2">
                                      <input
                                        type="date"
                                        id="dateToBeExported"
                                        name="dateToBeExported"
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                        value={
                                          bioSampleDetails?.dateToBeExported
                                            ? moment(
                                                bioSampleDetails?.dateToBeExported
                                              ).format("YYYY-MM-DD")
                                            : ""
                                        }
                                        className="form-control"
                                        onChange={(e) =>
                                          handleBioSampleDetails(e, "date")
                                        }
                                      />
                                      {bioSampleDetails?.dateExportedDateErrMsg && (
                                        <div className="error-message">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          Please fill Date to be Exported.
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row mt-3">
                                <div className="col-lg-12">
                                  <label
                                    className="form-check-label"
                                    htmlFor="flexRadioDefault1"
                                  >
                                    <a
                                      href=""
                                      className="font-weight-500"
                                      onClick={handleVaccineExpandToggle}
                                    >
                                      For Locally Manufactured Vaccines:{" "}
                                      {isVaccineExpanded ? "[-]" : "[+]"}
                                    </a>
                                  </label>
                                </div>
                              </div>
                              {isVaccineExpanded && (
                                <div className="row mt-3">
                                  <div className="col-lg-3">
                                    <label
                                      className="form-check-label"
                                      htmlFor=""
                                    >
                                      No. of Vials Produced
                                    </label>
                                  </div>
                                  <div className="col-lg-3">
                                    <input
                                      type="number"
                                      className={`form-control ${
                                        bioSampleDetails?.noOfvialsProducedErrMsg
                                          ? "border-danger op05"
                                          : ""
                                      }`}
                                      onChange={(e) => {
                                        if (e.target.value.length <= 5) {
                                          handleBioSampleDetails(e, "number");
                                        }
                                      }}
                                      name="noOfVialsProduced"
                                      disabled={
                                        isCancelRequest ||
                                        IsAcknowledgeRequest ||
                                        IsAcknowledge ||
                                        IsSubmitresultRequest
                                      }
                                      value={
                                        bioSampleDetails?.noOfVialsProduced
                                      }
                                    />
                                  </div>
                                  <div className="col-lg-3">
                                    <label
                                      className="form-check-label"
                                      htmlFor=""
                                    >
                                      Date Produced
                                    </label>
                                  </div>
                                  <div className="col-lg-3">
                                    <div
                                      className="input-group date"
                                      id="datepicker"
                                    >
                                      <input
                                        type="date"
                                        className={`form-control`}
                                        name="dateProduced"
                                        value={
                                          bioSampleDetails?.dateProduced
                                            ? moment(
                                                bioSampleDetails?.dateProduced
                                              ).format("YYYY-MM-DD")
                                            : ""
                                        }
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                        max={maxdate}
                                        onChange={(e) =>
                                          handleBioSampleDetails(e, "date")
                                        }
                                      />
                                    </div>
                                  </div>

                                  <div className="col-lg-3 mt-2">
                                    <label
                                      className="form-check-label"
                                      htmlFor=""
                                    >
                                      Substrate
                                    </label>
                                  </div>
                                  <div className="col-lg-3 mt-2">
                                    <input
                                      type="text"
                                      className={`form-control ${
                                        bioSampleDetails?.substrateErrMsg
                                          ? "border-danger op05"
                                          : ""
                                      }`}
                                      placeholder=""
                                      disabled={
                                        isCancelRequest ||
                                        IsAcknowledgeRequest ||
                                        IsAcknowledge ||
                                        IsSubmitresultRequest
                                      }
                                      maxLength={100}
                                      name="substrate"
                                      value={bioSampleDetails?.substrate}
                                      onChange={(e) =>
                                        handleBioSampleDetails(e, "string")
                                      }
                                    />
                                  </div>
                                </div>
                              )}

                              <div className="row mt-3">
                                <div className="col-lg-12">
                                  <label
                                    className="form-check-label"
                                    htmlFor="flexRadioDefault1"
                                  >
                                    <a
                                      href=""
                                      className="font-weight-500"
                                      onClick={handleHistoryExpandToggle}
                                    >
                                      History &amp; Remarks:{" "}
                                      {isHistoryExpanded ? "[-]" : "[+]"}
                                    </a>
                                  </label>
                                </div>
                              </div>
                              {isHistoryExpanded && (
                                <div className="row mt-3">
                                  <div className="col-lg-12">
                                    <label
                                      className="form-check-label"
                                      htmlFor=""
                                    >
                                      History & Remarks
                                    </label>
                                    <textarea
                                      className="form-control"
                                      id="floatingTextarea"
                                      name="history_Remarks"
                                      value={bioSampleDetails?.history_Remarks}
                                      disabled={
                                        isCancelRequest ||
                                        IsAcknowledgeRequest ||
                                        IsAcknowledge ||
                                        IsSubmitresultRequest
                                      }
                                      maxLength={500}
                                      onChange={(e) =>
                                        handleBioSampleDetails(e, "string")
                                      }
                                    />
                                    <p className="text-muted small mt-1">
                                      {bioSampleDetails?.history_Remarks
                                        ?.length || 0}{" "}
                                      / 500 characters
                                    </p>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                      {isCancelRequest ? (
                        <div className="personal-info">
                          <div className="clonable-block" data-toggle="cloner">
                            <div className="clonable" data-clone-number="1">
                              <div className="info-heading">
                                <h2>
                                  Reason(s) for cancellation
                                  <span className="star-red">*</span>
                                </h2>
                              </div>
                              <div className="info-content">
                                <textarea
                                  className="form-control"
                                  placeholder=""
                                  name="cancel-request-comments"
                                  value={cancelComments}
                                  onChange={(e) =>
                                    setCancelComments(e.target.value)
                                  }
                                  maxLength={500}
                                ></textarea>
                                {cancelCommentsErrMsg && (
                                  <div className="error-message">
                                    <FontAwesomeIcon
                                      className="me-1"
                                      icon={faCircleExclamation}
                                    />
                                    Please fill Reason(s) for cancellation.
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </Tab>
                  )}
                  {!(IsAcknowledge || IsSubmitresultRequest) && (
                    <Tab eventKey={2} title="Samples & Tests">
                      <div>
                        {rejectedTestsMessage && (
                          <div className="alert alert-warning">
                            {rejectedTestsMessage}
                          </div>
                        )}
                        {pageLoader || checkpageLoader ? (
                          <Loader />
                        ) : (
                          samplesAndTests &&
                          samplesAndTests.map(
                            (x: IBioSamplesAndTests, ind: number) => {
                              return (
                                <div className="personal-info">
                                  <div
                                    className="clonable-block"
                                    data-toggle="cloner"
                                  >
                                    <div
                                      className="clonable"
                                      data-clone-number={ind + 1}
                                    >
                                      <div className="info-heading">
                                        {amendCase !== "CASE4" &&
                                        !isCancelRequest &&
                                        !IsSubmitresultRequest &&
                                        !IsAcknowledge &&
                                        !IsAcknowledgeRequest ? (
                                          <ul className="card-icons float-end">
                                            <li>
                                              <button
                                                className="icon-button"
                                                title="New"
                                                onClick={handleAddSample}
                                              >
                                                <FontAwesomeIcon
                                                  icon={faPlus}
                                                />
                                              </button>
                                            </li>
                                            <li className="copy-button-container">
                                              <button
                                                className="icon-button"
                                                title="Copy"
                                                onClick={() =>
                                                  handleCopyButtonClick(ind)
                                                }
                                              >
                                                <FontAwesomeIcon
                                                  icon={faCopy}
                                                />
                                              </button>
                                              <input
                                                type="number"
                                                className="copy-input"
                                                min="1"
                                                value={copyCount}
                                                onChange={handleCopyInputChange}
                                              />
                                            </li>
                                            <li>
                                              <button
                                                className="icon-button"
                                                onClick={() =>
                                                  handleDeleteSample(x?.id)
                                                }
                                              >
                                                <FontAwesomeIcon
                                                  icon={faTrashCan}
                                                />
                                              </button>
                                            </li>
                                          </ul>
                                        ) : (
                                          ""
                                        )}
                                        <h2 className="pb-0">
                                          Serial number {ind + 1}
                                        </h2>
                                      </div>
                                      <div className="info-content">
                                        <div className="table-responsive mt-2 mb-2 ">
                                          <table className="table table-striped product_table start_table">
                                            <thead>
                                              <tr>
                                                <th className="w-20">
                                                  Sample Marking
                                                  <span className="star-red">
                                                    *
                                                  </span>
                                                </th>
                                                <th className="w-20">
                                                  Number of Samples
                                                  <span className="star-red">
                                                    *
                                                  </span>
                                                </th>
                                                <th className="w-20">
                                                  Batch No.
                                                </th>
                                                <th className="w-20">
                                                  Expiry Date
                                                </th>
                                                <th className="w-20">
                                                  Test Information
                                                  <span className="star-red">
                                                    *
                                                  </span>
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <input
                                                    type="text"
                                                    className={`form-control ${
                                                      x?.sampleMarkingErrMsg
                                                        ? "border-danger"
                                                        : ""
                                                    }`}
                                                    name="sampleMarking"
                                                    aria-label="Sample Marking"
                                                    disabled={
                                                      isCancelRequest ||
                                                      IsAcknowledgeRequest ||
                                                      IsAcknowledge ||
                                                      IsSubmitresultRequest
                                                    }
                                                    maxLength={100}
                                                    value={x?.sampleMarking}
                                                    onChange={handleSamplesAndTests(
                                                      ind,
                                                      "string"
                                                    )}
                                                  />
                                                  {x?.sampleMarkingErrMsg && (
                                                    <div className="error-message">
                                                      <FontAwesomeIcon
                                                        className="me-1"
                                                        icon={
                                                          faCircleExclamation
                                                        }
                                                      />
                                                      {x.sampleMarkingErrMsg}
                                                    </div>
                                                  )}
                                                </td>
                                                <td>
                                                  <input
                                                    type="number"
                                                    min="1"
                                                    name="noOfSamples"
                                                    className="form-control"
                                                    value={x?.noOfSamples ?? 1}
                                                    disabled={
                                                      amendCase == "CASE4" ||
                                                      isCancelRequest ||
                                                      IsAcknowledgeRequest ||
                                                      IsAcknowledge ||
                                                      IsSubmitresultRequest
                                                    }
                                                    onChange={handleSamplesAndTests(
                                                      ind,
                                                      "number"
                                                    )}
                                                  />
                                                </td>
                                                <td>
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder=""
                                                    name="batchNo"
                                                    disabled={
                                                      isCancelRequest ||
                                                      IsAcknowledgeRequest ||
                                                      IsAcknowledge ||
                                                      IsSubmitresultRequest
                                                    }
                                                    maxLength={30}
                                                    value={x?.batchNo}
                                                    onChange={handleSamplesAndTests(
                                                      ind,
                                                      "string"
                                                    )}
                                                  />
                                                </td>

                                                <td>
                                                  <div
                                                    className="input-group date"
                                                    id="datepicker"
                                                  >
                                                    <input
                                                      type="date"
                                                      className={`form-control`}
                                                      disabled={
                                                        isCancelRequest ||
                                                        IsAcknowledgeRequest ||
                                                        IsAcknowledge ||
                                                        IsSubmitresultRequest
                                                      }
                                                      name="expiryDate"
                                                      value={
                                                        x?.expiryDate
                                                          ? moment(
                                                              x.expiryDate
                                                            ).format(
                                                              "YYYY-MM-DD"
                                                            )
                                                          : ""
                                                      }
                                                      onChange={handleSamplesAndTests(
                                                        ind,
                                                        "date"
                                                      )}
                                                    />
                                                  </div>
                                                </td>
                                                <td>
                                                  <button
                                                    className={`btn btn-outline-success w-100 ${
                                                      x?.labBioTestDetailsErrMsg
                                                        ? "border-danger"
                                                        : ""
                                                    }`}
                                                    type="button"
                                                    onClick={() =>
                                                      handleShowSearchTestsModal(
                                                        ind
                                                      )
                                                    }
                                                    disabled={
                                                      amendCase == "CASE4" ||
                                                      isCancelRequest ||
                                                      IsAcknowledgeRequest ||
                                                      IsAcknowledge ||
                                                      IsSubmitresultRequest
                                                    }
                                                  >
                                                    Search Test
                                                  </button>
                                                  {x?.labBioTestDetailsErrMsg && (
                                                    <div className="error-message">
                                                      <FontAwesomeIcon
                                                        className="me-1"
                                                        icon={
                                                          faCircleExclamation
                                                        }
                                                      />
                                                      Please add Test
                                                      Information.
                                                    </div>
                                                  )}
                                                </td>
                                              </tr>
                                              {/*<tr>
                                                <td className="fnt-wg tr-ignore">
                                                  <div className="mb-3 ">
                                                    <div className="mb-2">
                                                      <label
                                                        htmlFor="staticEmail"
                                                        className="col-form-label"
                                                      >
                                                        Latitude (Decimal
                                                        Degrees)
                                                      </label>
                                                      <div className="input-group date">
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          placeholder={
                                                            showPlaceholder
                                                              ? "123.123456"
                                                              : ""
                                                          }
                                                          name="latitude"
                                                          value={x?.latitude}
                                                          maxLength={100}
                                                          disabled={
                                                            isCancelRequest ||
                                                            IsAcknowledgeRequest ||
                                                            IsAcknowledge ||
                                                            IsSubmitresultRequest
                                                          }
                                                          onChange={handleSamplesAndTests(
                                                            ind,
                                                            "string"
                                                          )}
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>

                                                <td className="fnt-wg tr-ignore">
                                                  <div className="mb-3 ">
                                                    <div className="mb-2">
                                                      <label
                                                        htmlFor="staticEmail"
                                                        className="col-form-label"
                                                      >
                                                        Longitude (Decimal
                                                        Degrees)
                                                      </label>
                                                      <div className="input-group date">
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          placeholder={
                                                            showPlaceholder
                                                              ? "123.123456"
                                                              : ""
                                                          }
                                                          name="longitude"
                                                          value={x?.longitude}
                                                          maxLength={100}
                                                          disabled={
                                                            isCancelRequest ||
                                                            IsAcknowledgeRequest ||
                                                            IsAcknowledge ||
                                                            IsSubmitresultRequest
                                                          }
                                                          onChange={handleSamplesAndTests(
                                                            ind,
                                                            "string"
                                                          )}
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>*/}

                                              {x.labBioTestDetails &&
                                                x.labBioTestDetails
                                                  .filter(
                                                    (test) =>
                                                      test.testDescription !==
                                                      ""
                                                  )
                                                  .map((test, testIndex) => (
                                                    <tr
                                                      key={`test-row-${ind}-${testIndex}`}
                                                    >
                                                      {/* <td className="fnt-wg tr-ignore">
                                                        <div className="mb-3">
                                                          <div className="mb-2">
                                                            <label
                                                              htmlFor={`samplesCount-${ind}-${testIndex}`}
                                                              className="col-form-label float-start"
                                                            >
                                                              Number of Samples
                                                              <span className="star-red">
                                                                *
                                                              </span>
                                                            </label>
                                                            <div className="input-group date">
                                                              <input
                                                                type="number"
                                                                id={`samplesCount-${ind}-${testIndex}`}
                                                                min="1"
                                                                className="form-control"
                                                                value={
                                                                  test.noOfSamples ??
                                                                  1
                                                                }
                                                                disabled={
                                                                  amendCase ==
                                                                    "CASE4" ||
                                                                  isCancelRequest ||
                                                                  IsAcknowledgeRequest ||
                                                                  IsAcknowledge ||
                                                                  IsSubmitresultRequest
                                                                }
                                                                onChange={(e) =>
                                                                  handleSamplesCountChange(
                                                                    ind,
                                                                    testIndex,
                                                                    Math.min(
                                                                      Number(
                                                                        e.target
                                                                          .value
                                                                      ),
                                                                      1000
                                                                    )
                                                                  )
                                                                }
                                                              />
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </td> */}
                                                      <td
                                                        className="br-1"
                                                        colSpan={3}
                                                      >
                                                        <div className="mb-3">
                                                          <div className="mb-2">
                                                            <div className="test-detail">
                                                              <div
                                                                id={`testDescription-${ind}-${test.labTestID}`}
                                                                className="test-description"
                                                                dangerouslySetInnerHTML={{
                                                                  __html:
                                                                    test.testDescription,
                                                                }}
                                                              />

                                                              {!(
                                                                amendCase ===
                                                                  "CASE4" ||
                                                                isCancelRequest ||
                                                                IsAcknowledgeRequest ||
                                                                IsAcknowledge ||
                                                                IsSubmitresultRequest
                                                              ) && (
                                                                <div
                                                                  className="test-remove-icon"
                                                                  onClick={() =>
                                                                    handleRemoveTest(
                                                                      x.labBioTestDetails,
                                                                      test.testDescription,
                                                                      ind
                                                                    )
                                                                  }
                                                                >
                                                                  <i className="bi bi-dash-circle"></i>
                                                                </div>
                                                              )}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </td>
                                                      <td
                                                        className="fnt-wg tr-ignore"
                                                        colSpan={2}
                                                      >
                                                        <div className="mb-3">
                                                          <div className="mb-2">
                                                            <label
                                                              htmlFor={`repeatCount-${ind}-${testIndex}`}
                                                              className="col-form-label float-start"
                                                            >
                                                              Number of Tests
                                                              <span className="star-red">
                                                                *
                                                              </span>
                                                            </label>
                                                            <div className="input-group date">
                                                              <input
                                                                type="number"
                                                                id={`repeatCount-${ind}-${testIndex}`}
                                                                min="1"
                                                                className="form-control"
                                                                maxLength={10}
                                                                value={
                                                                  repeatCounts[
                                                                    ind
                                                                  ]?.[
                                                                    testIndex
                                                                  ] ??
                                                                  test.nooftestsrequired
                                                                }
                                                                disabled={
                                                                  amendCase ==
                                                                    "CASE4" ||
                                                                  isCancelRequest ||
                                                                  IsAcknowledgeRequest ||
                                                                  IsAcknowledge ||
                                                                  IsSubmitresultRequest
                                                                }
                                                                onChange={(e) =>
                                                                  handleRepeatCountChange(
                                                                    ind,
                                                                    testIndex,
                                                                    Math.min(
                                                                      Number(
                                                                        e.target
                                                                          .value
                                                                      ),
                                                                      1000
                                                                    )
                                                                  )
                                                                }
                                                              />
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  ))}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          )
                        )}
                      </div>
                    </Tab>
                  )}
                  {!(IsAcknowledge || IsSubmitresultRequest) && (
                    <Tab eventKey={3} title="My Preference">
                      <div className="personal-info">
                        <div className="clonable-block">
                          <div className="clonable">
                            <div className="info-content">
                              <div className="row">
                                <div className="col-lg-6">
                                  <div className="row">
                                    <div className="col-lg-5">
                                      <label
                                        className="form-check-label"
                                        htmlFor="SpecialInstructions"
                                      >
                                        For Bacterial Culture Only
                                      </label>
                                    </div>
                                    <div className="col-lg-7 d-flex align-items-center">
                                      <input
                                        type="checkbox"
                                        className="form-check-input me-2"
                                        name="antimicrobialSusceptibilityTestRequired"
                                        onChange={(e) =>
                                          handleMyPreference(e, "checkbox")
                                        }
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsSubmitresultRequest ||
                                          IsAcknowledge ||
                                          amendCase === "CASE4"
                                        }
                                        checked={
                                          Preference?.antimicrobialSusceptibilityTestRequired
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="antimicrobialSusceptibilityTestRequired"
                                      >
                                        Antimicrobial Susceptibility Test
                                        Required
                                      </label>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-lg-6">
                                  <div className="row">
                                    <div className="col-lg-5">
                                      <label
                                        className="form-check-label"
                                        htmlFor="SpecialInstructions"
                                      >
                                        Special Instructions/ Additional
                                        Information
                                      </label>
                                    </div>
                                    <div className="col-lg-7">
                                      <textarea
                                        className="form-control"
                                        name="specialInstructions"
                                        onChange={(e) =>
                                          handleMyPreference(e, "input")
                                        }
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsSubmitresultRequest ||
                                          IsAcknowledge
                                        }
                                        maxLength={500}
                                        value={Preference?.specialInstructions}
                                      />
                                      <p className="text-muted small mt-1">
                                        {Preference?.specialInstructions
                                          ?.length || 0}{" "}
                                        / 500 characters
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="row mt-2 mt-lg-0">
                                    <div className="col-lg-5">
                                      <label
                                        className="form-check-label"
                                        htmlFor="otherRemarks"
                                      >
                                        Other Remarks
                                      </label>
                                    </div>
                                    <div className="col-lg-7">
                                      <textarea
                                        className="form-control"
                                        name="remarks"
                                        value={Preference?.remarks}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                        maxLength={500}
                                        onChange={(e) =>
                                          handleMyPreference(e, "input")
                                        }
                                      />
                                      <p className="text-muted small mt-1">
                                        {Preference?.remarks?.length || 0} / 500
                                        characters
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6 mt-3">
                                  <div className="row">
                                    <div className="col-lg-5">
                                      <label
                                        htmlFor="supportDocuments"
                                        className="form-check-label"
                                        onMouseEnter={handleMouseEnter}
                                        onMouseLeave={handleMouseLeave}
                                        title="Documents allowed: pdf, docx, doc, jpg, jpeg, png, xlsx, xls."
                                      >
                                        Support Documents
                                        <span className="csp-ml-5">
                                          <FontAwesomeIcon
                                            icon={faInfoCircle}
                                          />
                                        </span>
                                      </label>
                                    </div>
                                    <div className="col-lg-7">
                                      <input
                                        type="file"
                                        className="form-control"
                                        id="SupportDocuments"
                                        multiple
                                        onChange={handledFileChange}
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                      />
                                      {Preference?.supportDocumentName && (
                                        <div className="file-view mt-2">
                                          {Preference.supportDocumentName
                                            .split(", ")
                                            .map((name, index) => (
                                              <div
                                                key={index}
                                                className="file-item d-flex align-items-center"
                                              >
                                                <div className="file-name">
                                                  {name}
                                                </div>
                                                {!(
                                                  amendCase === "CASE4" ||
                                                  isCancelRequest ||
                                                  IsAcknowledgeRequest ||
                                                  IsAcknowledge ||
                                                  IsSubmitresultRequest
                                                ) && (
                                                  <div
                                                    className="test-remove-icon ml-2"
                                                    onClick={() =>
                                                      handleRemoveFile(name)
                                                    }
                                                    title="Remove file"
                                                  >
                                                    <i className="bi bi-dash-circle"></i>
                                                  </div>
                                                )}
                                              </div>
                                            ))}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                <div className="col-lg-6 mt-3">
                                  <div className="row">
                                    <div className="col-lg-5">
                                      <label
                                        className="form-check-label"
                                        htmlFor="modeOfReceiving"
                                      >
                                        Mode of receiving report
                                        <span className="star-red">*</span>
                                      </label>
                                    </div>
                                    <div className="col-lg-7">
                                      <select
                                        name="modeOfReceiving"
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                        value={Preference?.modeOfReceiving}
                                        onChange={(e) => {
                                          handleMyPreference(e, "number");

                                          const value = Number(e.target.value);

                                          if (value === 1 || value === 3) {
                                            setPreference((prevState) => ({
                                              ...prevState,
                                              hardcopy: "Yes",
                                            }));
                                          } else {
                                            setPreference((prevState) => ({
                                              ...prevState,
                                              hardcopy: "No",
                                            }));
                                          }
                                        }}
                                        className="form-select"
                                        aria-label="Mode of receiving report"
                                      >
                                        <option value="" selected>
                                          Select an option
                                        </option>
                                        <option value={2}>Email</option>
                                      </select>

                                      {Preference?.modeOfReceivingErrMsg && (
                                        <div className="error-message">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          Please select Mode of Report.
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                {Preference?.modeOfReceiving === 1 && (
                                  <div className="row mt-2">
                                    <div className="col-lg-6">
                                      <label className="form-check-label fw-bold mb-2">
                                        Please select the address for mailing:
                                      </label>
                                      <select
                                        name="mailingAddress"
                                        className="form-select mb-3"
                                        value={Preference?.mailingAddress}
                                        onChange={(e) =>
                                          handleMyPreference(e, "number")
                                        }
                                        disabled={
                                          isCancelRequest ||
                                          IsAcknowledgeRequest ||
                                          IsAcknowledge ||
                                          IsSubmitresultRequest
                                        }
                                      >
                                        <option value="" selected>
                                          Please Select address
                                        </option>
                                        <option value={1}>
                                          Same as mailing address
                                        </option>
                                        <option value={2}>
                                          Same as billing address
                                        </option>
                                        <option value={3}>
                                          Others (please specify)
                                        </option>
                                      </select>
                                      {Preference?.mailingAddressErrMsg && (
                                        <div className="text-danger mt-2">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          Please Select the address
                                        </div>
                                      )}

                                      {Preference?.mailingAddress === 3 && (
                                        <div className="col-lg-12">
                                          <textarea
                                            className="form-control mt-2"
                                            placeholder="Enter address"
                                            name="customAddress"
                                            value={
                                              Preference?.customAddress || ""
                                            }
                                            onChange={(e) =>
                                              handleMyPreference(e, "input")
                                            }
                                            disabled={
                                              isCancelRequest ||
                                              IsAcknowledgeRequest ||
                                              IsAcknowledge ||
                                              IsSubmitresultRequest
                                            }
                                          />
                                        </div>
                                      )}
                                      {Preference?.customAddressErrMsg && (
                                        <div className="text-danger mt-2">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          Please enter address
                                        </div>
                                      )}

                                      <div className="alert alert-warning mt-3">
                                        Please note that NParks is not liable
                                        for lost mail, and any additional copies
                                        of laboratory reports are subject to
                                        additional charges.
                                      </div>

                                      <div className="form-check mt-3">
                                        <input
                                          type="checkbox"
                                          className="form-check-input mt-2"
                                          id="acknowledgeCheckbox"
                                          name="acknowledge"
                                          disabled={
                                            isCancelRequest ||
                                            IsAcknowledgeRequest ||
                                            IsAcknowledge ||
                                            IsSubmitresultRequest
                                          }
                                          checked={
                                            Preference?.acknowledge || false
                                          }
                                          onChange={(e) =>
                                            handleMyPreference(e, "checkbox")
                                          }
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="acknowledgeCheckbox"
                                        >
                                          I acknowledge the above information
                                        </label>
                                      </div>

                                      {Preference?.acknowledgeErrMsg && (
                                        <div className="text-danger mt-2">
                                          <FontAwesomeIcon
                                            className="me-1"
                                            icon={faCircleExclamation}
                                          />
                                          You must acknowledge before proceeding
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Tab>
                  )}
                  {(IsSubmitresultRequest || IsAcknowledge) && (
                    <Tab eventKey={4} title="Results">
                      {samplesAndTests &&
                        samplesAndTests
                          .filter((sample) => {
                            return sample.labBioTestDetails.some(
                              (test: any) => {
                                const isValidTest =
                                  test.isThirdPartyLab === 1 &&
                                  test.rowId === testRowId &&
                                  test.thirdPartyNric === customerNRIC &&
                                  (test.testStatus === null ||
                                    test.testStatus !== 8);

                                return isValidTest;
                              }
                            );
                          })
                          .map(
                            (
                              sample: IBioSamplesAndTests,
                              sampleIndex: number
                            ) => {
                              return (
                                <div
                                  className="personal-info"
                                  key={sampleIndex}
                                >
                                  <div
                                    className="clonable-block"
                                    data-toggle="cloner"
                                  >
                                    <div
                                      className="clonable"
                                      data-clone-number={sampleIndex + 1}
                                    >
                                      <div className="info-heading">
                                        <h2 className="pb-0">
                                          Serial number {sampleIndex + 1}
                                        </h2>
                                      </div>

                                      <div className="info-content">
                                        <div className="table-responsive mt-2 mb-2">
                                          <table className="table table-striped product_table start_table">
                                            <thead> </thead>

                                            <tbody>
                                              <div>
                                                {sample.labBioTestDetails &&
                                                  sample.labBioTestDetails
                                                    .filter((test: any) => {
                                                      const isValidTest =
                                                        test.isThirdPartyLab ===
                                                          1 &&
                                                        test.thirdPartyNric ===
                                                          customerNRIC &&
                                                        test.rowId ===
                                                          testRowId &&
                                                        (test.testStatus ===
                                                          null ||
                                                          test.testStatus !==
                                                            8);

                                                      return isValidTest;
                                                    })
                                                    .map((test, testIndex) => (
                                                      <tr
                                                        key={`test-row-${sampleIndex}-${test.labTestID}`}
                                                      >
                                                        <td className="br-1">
                                                          <div className="mb-3">
                                                            <div className="mb-2">
                                                              <div className="heading-test">
                                                                <h2 className="pb-0">
                                                                  {
                                                                    <div
                                                                      id={`testDescription-${sampleIndex}-${test.labTestID}`}
                                                                      className="test-description"
                                                                      dangerouslySetInnerHTML={{
                                                                        __html:
                                                                          test.testDescription,
                                                                      }}
                                                                    />
                                                                  }
                                                                </h2>
                                                              </div>
                                                            </div>
                                                          </div>

                                                          <div className="info-content">
                                                            <div className="table table-striped product_table start_table">
                                                              <div className="d-flex flex-row justify-content-between align-items-center">
                                                                <div className="d-flex flex-column">
                                                                  <div className="d-flex flex-row align-items-center mt-2 mt-lg-0">
                                                                    <div className="col-lg-5">
                                                                      <label
                                                                        className="form-check-label"
                                                                        htmlFor="sampleMarking"
                                                                      >
                                                                        Sample
                                                                        Marking
                                                                      </label>
                                                                    </div>
                                                                    <div className="col-lg-7">
                                                                      <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder=""
                                                                        value={
                                                                          sample?.sampleMarking
                                                                        }
                                                                        name="sampleMarking"
                                                                        disabled
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                                <div className="d-flex flex-column">
                                                                  <div className="d-flex flex-row align-items-center">
                                                                    <div className="col-lg-5">
                                                                      <label
                                                                        htmlFor="supportDocuments"
                                                                        className="form-check-label"
                                                                        onMouseEnter={
                                                                          handleMouseEnter
                                                                        }
                                                                        onMouseLeave={
                                                                          handleMouseLeave
                                                                        }
                                                                        title="Documents allowed:pdf,docx,doc,jpg,jpeg,png,xlsx,xls."
                                                                      >
                                                                        Result
                                                                        Documents
                                                                        <span
                                                                          className="csp-ml-5"
                                                                        >
                                                                          <FontAwesomeIcon
                                                                            icon={
                                                                              faInfoCircle
                                                                            }
                                                                          />
                                                                        </span>
                                                                      </label>
                                                                    </div>
                                                                    <div className="col-lg-7">
                                                                      <input
                                                                        type="file"
                                                                        className="form-control"
                                                                        id="ResultDocuments"
                                                                        disabled={
                                                                          isCancelRequest ||
                                                                          IsAcknowledgeRequest ||
                                                                          IsAcknowledge
                                                                        }
                                                                        onChange={(
                                                                          e
                                                                        ) =>
                                                                          handledFiledChange(
                                                                            sampleIndex,
                                                                            test.labTestID ??
                                                                              "",

                                                                            e
                                                                          )
                                                                        }
                                                                        multiple
                                                                      />

                                                                      {test?.ResultDocumentName ? (
                                                                        <div className="file-view">
                                                                          {
                                                                            test?.ResultDocumentName
                                                                          }
                                                                        </div>
                                                                      ) : (
                                                                        ""
                                                                      )}
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>

                                                            <div className="row">
                                                              {(test.labBIOTestResult &&
                                                              test
                                                                .labBIOTestResult
                                                                .length > 0
                                                                ? test.labBIOTestResult
                                                                : [
                                                                    defaultTestResult,
                                                                  ]
                                                              ).map(
                                                                (
                                                                  result,
                                                                  resultIndex
                                                                ) => (
                                                                  <div
                                                                    className="row mt-2"
                                                                    key={`result-${test.labTestID}-${resultIndex}`}
                                                                  >
                                                                    {IsSubmitresultRequest && (
                                                                      <>
                                                                        <div className="info-heading">
                                                                          <ul className="card-icons float-end">
                                                                            <li>
                                                                              <button
                                                                                className="icon-button"
                                                                                title="New"
                                                                                onClick={() =>
                                                                                  handleAddTestResult(
                                                                                    sampleIndex,
                                                                                    test.labTestID ??
                                                                                      ""
                                                                                  )
                                                                                }
                                                                              >
                                                                                <FontAwesomeIcon
                                                                                  icon={
                                                                                    faPlus
                                                                                  }
                                                                                />
                                                                              </button>
                                                                            </li>
                                                                            <li className="copy-button-container">
                                                                              <button
                                                                                className="icon-button"
                                                                                title="Copy"
                                                                                onClick={() =>
                                                                                  handledCopyButtonClick(
                                                                                    sampleIndex,
                                                                                    test.labTestID ??
                                                                                      "",
                                                                                    resultIndex
                                                                                  )
                                                                                }
                                                                              >
                                                                                <FontAwesomeIcon
                                                                                  icon={
                                                                                    faCopy
                                                                                  }
                                                                                />
                                                                              </button>
                                                                            </li>

                                                                            {resultIndex !==
                                                                              0 && (
                                                                              <li>
                                                                                <button
                                                                                  className="icon-button"
                                                                                  onClick={() =>
                                                                                    handleDeleteTestResult(
                                                                                      sampleIndex,
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )
                                                                                  }
                                                                                  title="Delete"
                                                                                >
                                                                                  <FontAwesomeIcon
                                                                                    icon={
                                                                                      faTrashCan
                                                                                    }
                                                                                  />
                                                                                </button>
                                                                              </li>
                                                                            )}
                                                                          </ul>
                                                                          <h2 className="labresults-heading">
                                                                            {resultIndex ===
                                                                            0
                                                                              ? "Test Result"
                                                                              : `Additional Result ${resultIndex}`}
                                                                          </h2>
                                                                        </div>
                                                                      </>
                                                                    )}

                                                                    <>
                                                                      {test.isPostMartem ===
                                                                        0 && (
                                                                        <>
                                                                          <div className="row align-items-center">
                                                                            <div className="col-lg-6">
                                                                              <label
                                                                                className="form-check-label"
                                                                                htmlFor={`resultcode-${sampleIndex}-${test.labTestID}-${resultIndex}`}
                                                                              >
                                                                                Result
                                                                                Code
                                                                                <span className="star-red">
                                                                                  *
                                                                                </span>
                                                                              </label>
                                                                              <Select
                                                                                classNamePrefix="rs"
                                                                                options={
                                                                                  ResultCodeOptions
                                                                                }
                                                                                value={
                                                                                  ResultCodeOptions.find(
                                                                                    (
                                                                                      option
                                                                                    ) =>
                                                                                      option.value ===
                                                                                      result.resultcode
                                                                                  ) ||
                                                                                  null
                                                                                }
                                                                                isDisabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSelectChange(
                                                                                  sampleIndex,
                                                                                  "resultcode",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                              {result?.resultcodeErrMsg && (
                                                                                <div className="error-message">
                                                                                  <FontAwesomeIcon
                                                                                    className="me-1"
                                                                                    icon={
                                                                                      faCircleExclamation
                                                                                    }
                                                                                  />
                                                                                  Please
                                                                                  fill
                                                                                  Result
                                                                                  Code.
                                                                                </div>
                                                                              )}
                                                                            </div>

                                                                            <div className="col-lg-6">
                                                                              <label className="form-check-label">
                                                                                Units
                                                                              </label>
                                                                              <textarea
                                                                                id="units"
                                                                                className="form-control"
                                                                                name="units"
                                                                                value={
                                                                                  result?.units ||
                                                                                  ""
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                disabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "string",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                            </div>
                                                                          </div>

                                                                          <div className="row">
                                                                            <div className="col-lg-6">
                                                                              <label className="form-check-label">
                                                                                Testing
                                                                                Instructions
                                                                                <span className="star-red">
                                                                                  *
                                                                                </span>
                                                                              </label>
                                                                              <textarea
                                                                                id="testingInstruction"
                                                                                className="form-control"
                                                                                name="testingInstructions"
                                                                                value={
                                                                                  result?.testingInstructions ||
                                                                                  ""
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                disabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "string",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />

                                                                              {result?.testingInstructionsErrMsg && (
                                                                                <div className="error-message">
                                                                                  <FontAwesomeIcon
                                                                                    className="me-1"
                                                                                    icon={
                                                                                      faCircleExclamation
                                                                                    }
                                                                                  />
                                                                                  Please
                                                                                  fill
                                                                                  Testing
                                                                                  Instructions.
                                                                                </div>
                                                                              )}
                                                                            </div>

                                                                            <div className="col-lg-6">
                                                                              <label className="form-check-label">
                                                                                Remarks
                                                                                for
                                                                                Third
                                                                                Party
                                                                                Laboratory
                                                                                <span className="star-red">
                                                                                  *
                                                                                </span>
                                                                              </label>
                                                                              <textarea
                                                                                id="remarksForThirdParty"
                                                                                className="form-control"
                                                                                name="remarksForThirdParty"
                                                                                value={
                                                                                  result?.remarksForThirdParty ||
                                                                                  ""
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                disabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "string",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                              {result?.remarksForThirdPartyErrMsg && (
                                                                                <div className="error-message">
                                                                                  <FontAwesomeIcon
                                                                                    className="me-1"
                                                                                    icon={
                                                                                      faCircleExclamation
                                                                                    }
                                                                                  />
                                                                                  Please
                                                                                  fill
                                                                                  Remarks
                                                                                  for
                                                                                  Third
                                                                                  Party
                                                                                  Laboratory.
                                                                                </div>
                                                                              )}
                                                                            </div>
                                                                          </div>

                                                                          <div className="row">
                                                                            <div className="col-lg-3">
                                                                              <label className="form-check-label">
                                                                                Symbol
                                                                                1
                                                                              </label>
                                                                              <select
                                                                                className="form-select"
                                                                                name="Symbol1"
                                                                                value={
                                                                                  result?.Symbol1 ||
                                                                                  ""
                                                                                }
                                                                                disabled={
                                                                                  amendCase ==
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "number",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              >
                                                                                <option value="">
                                                                                  Select
                                                                                </option>
                                                                                <option value="1">
                                                                                  &lt;
                                                                                </option>
                                                                                <option value="2">
                                                                                  &gt;
                                                                                </option>
                                                                                <option value="3">
                                                                                  +
                                                                                </option>
                                                                                <option value="4">
                                                                                  -
                                                                                </option>
                                                                              </select>
                                                                            </div>
                                                                            <div className="col-lg-3">
                                                                              <label className="form-check-label">
                                                                                Readings
                                                                                1
                                                                              </label>
                                                                              <input
                                                                                type="number"
                                                                                className="form-control"
                                                                                name="Readings"
                                                                                step="0.01"
                                                                                disabled={
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                value={
                                                                                  result?.Readings ||
                                                                                  0
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "decimal",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                            </div>
                                                                            <div className="col-lg-3">
                                                                              <label className="form-check-label">
                                                                                Symbol
                                                                                2
                                                                              </label>
                                                                              <select
                                                                                className="form-select"
                                                                                name="Symbol2"
                                                                                value={
                                                                                  result?.Symbol2 ||
                                                                                  ""
                                                                                }
                                                                                disabled={
                                                                                  amendCase ==
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "number",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              >
                                                                                <option value="">
                                                                                  Select
                                                                                </option>
                                                                                <option value="1">
                                                                                  E
                                                                                </option>
                                                                                <option value="2">
                                                                                  /
                                                                                </option>
                                                                              </select>
                                                                            </div>

                                                                            <div className="col-lg-3">
                                                                              <label className="form-check-label">
                                                                                Reading
                                                                                2
                                                                              </label>
                                                                              <input
                                                                                type="number"
                                                                                className="form-control"
                                                                                name="Readings2"
                                                                                step="0.01"
                                                                                disabled={
                                                                                  amendCase ==
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                value={
                                                                                  result?.Readings2 ||
                                                                                  0
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "decimal",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                            </div>
                                                                          </div>

                                                                          <div className="row">
                                                                            <div className="col-lg-3">
                                                                              <label htmlFor="Positive">
                                                                                Positive
                                                                              </label>
                                                                              <input
                                                                                type="text"
                                                                                id="Positive"
                                                                                className="form-control"
                                                                                name="Positive"
                                                                                value={
                                                                                  result?.Positive ||
                                                                                  ""
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                disabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "string",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                            </div>

                                                                            <div className="col-lg-3">
                                                                              <label htmlFor="Negative">
                                                                                Negative
                                                                              </label>
                                                                              <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="Negative"
                                                                                value={
                                                                                  result?.Negative ||
                                                                                  ""
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                disabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "string",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                            </div>

                                                                            <div className="col-lg-3">
                                                                              <label htmlFor="Indefinite">
                                                                                Indefinite
                                                                              </label>
                                                                              <input
                                                                                type="text"
                                                                                id="Indefinite"
                                                                                className="form-control"
                                                                                name="Indefinite"
                                                                                value={
                                                                                  result?.Indefinite ||
                                                                                  ""
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                disabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "string",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                            </div>

                                                                            <div className="col-lg-3">
                                                                              <label htmlFor="ResultRemarks">
                                                                                Remarks
                                                                              </label>
                                                                              <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="ResultRemarks"
                                                                                value={
                                                                                  result?.ResultRemarks ||
                                                                                  ""
                                                                                }
                                                                                maxLength={
                                                                                  100
                                                                                }
                                                                                disabled={
                                                                                  amendCase ===
                                                                                    "CASE4" ||
                                                                                  isCancelRequest ||
                                                                                  IsAcknowledgeRequest ||
                                                                                  IsAcknowledge
                                                                                }
                                                                                onChange={handledSamplesAndTestsChange(
                                                                                  sampleIndex,
                                                                                  "string",
                                                                                  test.labTestID ??
                                                                                    "",
                                                                                  resultIndex
                                                                                )}
                                                                              />
                                                                            </div>
                                                                          </div>
                                                                        </>
                                                                      )}
                                                                    </>
                                                                    <>
                                                                      {test.isPostMartem ===
                                                                        1 && (
                                                                        <>
                                                                          <div className="row">
                                                                            <div className="col-lg-6">
                                                                              <div className="row mt-2 mt-lg-0">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor={`resultcode-${sampleIndex}-${test.labTestID}-${resultIndex}`}
                                                                                  >
                                                                                    Result
                                                                                    Code
                                                                                    <span className="star-red">
                                                                                      *
                                                                                    </span>
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <Select
                                                                                    classNamePrefix="rs"
                                                                                    options={
                                                                                      ResultCodeOptions
                                                                                    }
                                                                                    value={
                                                                                      ResultCodeOptions.find(
                                                                                        (
                                                                                          option
                                                                                        ) =>
                                                                                          option.value ===
                                                                                          result.resultcode
                                                                                      ) ||
                                                                                      null
                                                                                    }
                                                                                    isDisabled={
                                                                                      amendCase ==
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                    onChange={handledSelectChange(
                                                                                      sampleIndex,
                                                                                      "resultcode",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                  />
                                                                                  {result?.resultcodeErrMsg && (
                                                                                    <div className="error-message">
                                                                                      <FontAwesomeIcon
                                                                                        className="me-1"
                                                                                        icon={
                                                                                          faCircleExclamation
                                                                                        }
                                                                                      />
                                                                                      Please
                                                                                      fill
                                                                                      Result
                                                                                      Code
                                                                                    </div>
                                                                                  )}
                                                                                </div>
                                                                              </div>
                                                                            </div>

                                                                            <div className="col-lg-6">
                                                                              <div className="row">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor={`units-${sampleIndex}-${test.labTestID}`}
                                                                                  >
                                                                                    Units
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="units"
                                                                                    value={
                                                                                      result?.units ||
                                                                                      ""
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    disabled={
                                                                                      amendCase ==
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                  />
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                          </div>

                                                                          <div className="row">
                                                                            <div className="col-lg-6">
                                                                              <div className="row">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor={`testingInstructions-${sampleIndex}-${test.labTestID}`}
                                                                                  >
                                                                                    Testing
                                                                                    Instructions
                                                                                    <span className="star-red">
                                                                                      *
                                                                                    </span>
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="testingInstructions"
                                                                                    value={
                                                                                      result?.testingInstructions ||
                                                                                      ""
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    disabled={
                                                                                      amendCase ==
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                  />
                                                                                  {result?.testingInstructionsErrMsg && (
                                                                                    <div className="error-message">
                                                                                      <FontAwesomeIcon
                                                                                        className="me-1"
                                                                                        icon={
                                                                                          faCircleExclamation
                                                                                        }
                                                                                      />
                                                                                      Please
                                                                                      fill
                                                                                      Testing
                                                                                      Instructions.
                                                                                    </div>
                                                                                  )}
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                            <div className="col-lg-6">
                                                                              <div className="row mt-2 mt-lg-0">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="Parasitology"
                                                                                  >
                                                                                    Remarks
                                                                                    for
                                                                                    Third
                                                                                    Party
                                                                                    Laboratory{" "}
                                                                                    <span className="star-red">
                                                                                      *
                                                                                    </span>
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="remarksForThirdParty"
                                                                                    value={
                                                                                      result?.remarksForThirdParty ||
                                                                                      ""
                                                                                    }
                                                                                    disabled={
                                                                                      amendCase ==
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                  />

                                                                                  {result?.remarksForThirdPartyErrMsg && (
                                                                                    <div className="error-message">
                                                                                      <FontAwesomeIcon
                                                                                        className="me-1"
                                                                                        icon={
                                                                                          faCircleExclamation
                                                                                        }
                                                                                      />
                                                                                      Please
                                                                                      fill
                                                                                      Remarks
                                                                                      for
                                                                                      Third
                                                                                      Party
                                                                                      Laboratory.
                                                                                    </div>
                                                                                  )}
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                          <div className="row">
                                                                            <div className="col-lg-6">
                                                                              <div className="row">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor={`report-${sampleIndex}-${test.labTestID}`}
                                                                                  >
                                                                                    Report
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="report"
                                                                                    value={
                                                                                      result?.report ||
                                                                                      ""
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    disabled={
                                                                                      amendCase ==
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                  />
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                            <div className="col-lg-6">
                                                                              <div className="row mt-2 mt-lg-0">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="Parasitology"
                                                                                  >
                                                                                    Parasitology
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="Parasitology"
                                                                                    value={
                                                                                      result?.Parasitology ||
                                                                                      ""
                                                                                    }
                                                                                    disabled={
                                                                                      amendCase ==
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                  />
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                          <div className="row">
                                                                            <div className="col-lg-6">
                                                                              <div className="row">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="Microbiology"
                                                                                  >
                                                                                    Microbiology
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="Microbiology"
                                                                                    value={
                                                                                      result?.Microbiology ||
                                                                                      ""
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    disabled={
                                                                                      amendCase ==
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                  />
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                            <div className="col-lg-6">
                                                                              <div className="row mt-2 mt-lg-0">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="Histopathology"
                                                                                  >
                                                                                    Histopathology
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="Histopathology"
                                                                                    value={
                                                                                      result?.Histopathology ||
                                                                                      ""
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                    disabled={
                                                                                      amendCase ==
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                  />
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                          <div className="row">
                                                                            <div className="col-lg-6">
                                                                              <div className="row">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="ourreference"
                                                                                  >
                                                                                    Our
                                                                                    Reference
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="ourreference"
                                                                                    value={
                                                                                      result?.ourreference ||
                                                                                      ""
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    disabled={
                                                                                      amendCase ==
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                  />
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                            <div className="col-lg-6">
                                                                              <div className="row mt-2 mt-lg-0">
                                                                                <div className="col-lg-5">
                                                                                  <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="finalDiagnosis"
                                                                                  >
                                                                                    Final
                                                                                    Diagnosis
                                                                                  </label>
                                                                                </div>
                                                                                <div className="col-lg-7">
                                                                                  <textarea
                                                                                    className="form-control"
                                                                                    name="finalDiagnosis"
                                                                                    value={
                                                                                      result?.finalDiagnosis ||
                                                                                      ""
                                                                                    }
                                                                                    maxLength={
                                                                                      500
                                                                                    }
                                                                                    onChange={handledSamplesAndTestsChange(
                                                                                      sampleIndex,
                                                                                      "string",
                                                                                      test.labTestID ??
                                                                                        "",
                                                                                      resultIndex
                                                                                    )}
                                                                                    disabled={
                                                                                      amendCase ==
                                                                                        "CASE4" ||
                                                                                      isCancelRequest ||
                                                                                      IsAcknowledgeRequest ||
                                                                                      IsAcknowledge
                                                                                    }
                                                                                  />
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        </>
                                                                      )}
                                                                    </>
                                                                  </div>
                                                                )
                                                              )}
                                                            </div>
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    ))}
                                              </div>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          )}
                      <br />
                    </Tab>
                  )}
                </Tabs>

                {showAmendmentHistory && amendmentHistory?.length > 0 && (
                  <AmendmentGrid
                    data={amendmentHistory}
                    setData={setAmendmentHistory}
                    isLoading
                  />
                )}

                <div className="text-end mt-3 mb-3">
                  {!IsSubmitresultRequest && !IsAcknowledge ? (
                    <button
                      className="btn btn-d btn-secondary px-4"
                      onClick={handlePreviousClick}
                    >
                      Previous
                    </button>
                  ) : null}
                  {(IsSubmitresultRequest || IsAcknowledge) && (
                    <>
                      <button
                        className="btn btn-d btn-secondary px-4"
                        onClick={handledPreviousClick}
                      >
                        Previous
                      </button>

                      <button
                        className="btn btn-d btn-primary px-4"
                        onClick={
                          IsSubmitresultRequest
                            ? handledSaveResultClick
                            : handleACKResultClick
                        }
                      >
                        {IsSubmitresultRequest ? "Submit" : "Acknowledge"}
                      </button>
                    </>
                  )}

                  {!IsAcknowledgeRequest &&
                    !IsAcknowledge &&
                    !isCancelRequest &&
                    !IsSubmitresultRequest && (
                      <>
                        {actionType !== TypeOfApplicationEnum.amendment && (
                          <button
                            className="btn btn-d btn-secondry  px-4"
                            onClick={handleSaveDraftClick}
                            disabled={btnNameForLoader === "submit-req"}
                          >
                            {btnNameForLoader === "submit-req"
                              ? "Submitting..."
                              : "Save Draft"}
                          </button>
                        )}
                        <button
                          className="btn btn-d btn-primary nextBtn"
                          name="next-click"
                          type="button"
                          onClick={validateForm}
                        >
                          Next
                          {btnNameForLoader == "next-click" ? (
                            <Spinner
                              className="btn-spinner"
                              animation="border"
                              variant="light"
                            />
                          ) : (
                            ""
                          )}
                        </button>
                      </>
                    )}
                  {!IsAcknowledgeRequest &&
                    !IsAcknowledge &&
                    !IsSubmitresultRequest &&
                    !cancelButtonHidden &&
                    isCancelRequest && (
                      <button
                        className="btn btn-d btn-primary nextBtn"
                        name="cancel-request-btn"
                        type="button"
                        onClick={cancelRequest}
                        disabled={btnNameForLoader === "cancel-request-btn"}
                      >
                        Cancel Request
                        {btnNameForLoader == "cancel-request-btn" ? (
                          <Spinner
                            className="btn-spinner"
                            animation="border"
                            variant="light"
                          />
                        ) : (
                          ""
                        )}
                      </button>
                    )}
                </div>
              </div>
            </div>
          </div>
        )}
      </Container>
      {amendCase === "CASE4" ||
      IsAcknowledgeRequest ||
      IsAcknowledge ||
      IsSubmitresultRequest ||
      isCancelRequest ? (
        ""
      ) : (
        <Modal
          className="popup-2"
          show={showSearchTestsModal}
          onHide={handleCloseSearchTestsModal}
          backdrop="static"
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Assign Tests</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleFormSubmit}>
              <h3>Search for Other Tests</h3>
              <div className="tests-cnt pb-2">
                <div className="mb-3 row">
                  <label
                    htmlFor="flexCheckDesc"
                    className="col-sm-3 col-form-label"
                  >
                    Test Laboratory
                    <span className="star-red">*</span>
                  </label>
                  <div className="col-sm-9">
                    <select
                      className="form-select"
                      aria-label="Test Laboratory"
                      value={selectedTestLaboratory}
                      onChange={(e) => {
                        setSelectedTestLaboratory(e.target.value);
                      }}
                    >
                      <option selected value="All-laboratories">
                        All laboratories
                      </option>
                      {labtestoptions.map((item, index) => (
                        <option key={index} value={item.labGroup}>
                          {item.labGroup}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="mb-1 row"></div>
                <div className="mb-3 row">
                  <label
                    htmlFor="flexCheckDesc"
                    className="col-sm-3 col-form-label"
                  >
                    Test Description
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      id="flexCheckDesc"
                      placeholder=""
                      autoComplete="off"
                      value={testDescription}
                      required
                      onChange={(e) => setTestDescription(e.target.value)}
                      disabled={
                        amendCase == "CASE4" ||
                        isCancelRequest ||
                        IsAcknowledgeRequest ||
                        IsAcknowledge ||
                        IsSubmitresultRequest
                      }
                      className={`form-control ${
                        !testDescription ? "border-danger op05" : ""
                      }`}
                    />
                    <br />

                    <Button
                      variant="primary"
                      className="float-end"
                      name="submit-reqq"
                      disabled={searchLoading}
                      onClick={handleSearch}
                    >
                      Search
                      {btnNameForLoader == "submit-reqq" ? (
                        <Spinner
                          className="btn-spinner"
                          animation="border"
                          variant="light"
                        />
                      ) : (
                        ""
                      )}
                    </Button>
                  </div>
                </div>
              </div>
              <h3>Examination/Diagnostic Tests</h3>
              <div
                className="tests-cnt csp-maxh-200 csp-overflow-y-auto csp-display-block"
              >
                <h4>Examination/Diagnostic Tests</h4>
                {testOptions
                  .slice()
                  .sort((a, b) => {
                    const stripHtml = (text: any) =>
                      text.replace(/<[^>]*>/g, "").trim();
                    return stripHtml(a.description).localeCompare(
                      stripHtml(b.description)
                    );
                  })
                  .map((test, index) => (
                    <div className="form-check" key={index}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value={test.description}
                        id={`testOption${index}`}
                        checked={test.isSelected}
                        onChange={(e) =>
                          toggleTestSelection(
                            test.labCodeMasterID,
                            e.target.checked
                          )
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`testOption${index}`}
                        dangerouslySetInnerHTML={{ __html: test.description }}
                      ></label>
                    </div>
                  ))}
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseSearchTestsModal}>
              Close
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                handleAddTests();
                handleCloseSearchTestsModal();
              }}
            >
              Add
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <Footer />
    </>
  );
};

export default CAVSBioSamplesAndTests;
